import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {FontList} from '../FontList';
import {Detector} from '../Detector';
import {AppService} from '../app.service';
import {CardImage, CardText, ImageType, TextShape} from "../CardCreator/CardImage";
import cardBacks, {CardBack, CardHole, HoleType} from "../CardCreator/CardBacks";
import {Formatter} from "../CardCreator/Formatter";
import templates, {Template} from "../CardCreator/Templates";
import {CardCreatorStyle, StyleCreatorCutout, StyleCreatorText} from "../CardCreator/CardCreateSave";
import {HoleCutter} from "../CardCreator/HoleCutter";
import {CreatingCard} from "../CardCreator/CreatingCard";

declare let $: any;
declare let Konva: any;
declare let window: any;

@Component({
  selector: 'card-creator-mobile',
  templateUrl: './cardCreatorMobile.component.html',
  styleUrls: ['./cardCreatorMobile.component.css', '../app.component.css']
})
export class CardCreatorMobileComponent implements OnInit, OnDestroy {
  templateList: Template[] = templates;
  cardBackList: CardBack[] = cardBacks;
  cardBackHeight = 0;
  previewedCard = '';
  originalCard = null;
  hasMadeStage: boolean = false;
  stage: any = null;
  runOverwrite = false;
  snapshotDefer = null;
  tempImageData = null;

  layer: any = null;
  imageSave: any = null;
  groupSave: any = null;
  fileUploading: any = null;
  resizeImageData: any = null;
  imageDefer = null;
  drawCanvasDefer = null;

  canvasHeight: number = 0;
  canvasWidth: number = 0;

  d: Detector = null;

  cbData: any = null;
  cbOriginalData: any = null;
  cbImgData: any = null;
  cbImgData1: any = null;
  cbChangeCtx: any = null;
  colorVal = 30;

  hueSlider = 180;
  satSlider = 180;
  lumSlider = 180;
  colorTest = '#ffffff';

  updatePreviewTimer = null;
  runningUpdate = false;

  inFormatMode = false;
  subscription = null;
  cardBackColor = "";

  cutter: HoleCutter = new HoleCutter();
  formatter: Formatter = new Formatter();
  editingImage = true;
  generatedCardBack = '';

  cropCornersSize = this.app.isMobile ? 32 : 16;
  processingChange = false;
  showBackOptions = false;

  constructor(public app: AppService, private zone: NgZone) {
    console.log("CARD CREATOR CONSTRUCTOR");
    this.app.selectedCardBack = this.cardBackList[0];
    var hole = new CardHole(0, 12.5, 25, 75, 50, false, HoleType.none, false);
    this.app.creating = new CreatingCard(0,[],[], [hole], this.cardBackList[0]);
    this.d = new Detector();
    this.app.fonts = new FontList();
    this.app.fonts.fontList = this.app.fonts.fontList.filter((font) => {
      font.allowed = this.d.detect(font.name);
      return font.allowed;
    });
    this.resetAllValuesToDefault();
    this.resetSubscription();
    $('#container').on('touchstart', (event) => {
      console.log("Touch event: ", event);
    });
    setTimeout(() => {
      this.createHolesInBack();
    }, 1500);
    setTimeout(() => {
      this.setFontList();
    }, 1500);
  }

  setFontList() {
    this.d = new Detector();
    if (this.d.detect('Cookie')) {
      this.app.fonts = new FontList();
      this.app.fonts.fontList = this.app.fonts.fontList.filter((font) => {
        font.allowed = this.d.detect(font.name);
        return font.allowed;
      });
    } else {
      setTimeout(() => {
        this.setFontList();
      }, 300);
    }
  }

  resetSubscription = () => {
    if (this.app.designerSub !== null) {
      this.app.designerSub.unsubscribe();
      this.app.designerSub = null;
    }
    this.app.designerSub = this.app.broadcaster.subscribe((value) => {
      this.broadCastHandle(value);
    });
  }

  resetAllValuesToDefault() {
    this.cardBackHeight = 0;
    this.previewedCard = '';
    this.originalCard = null;
    this.stage = null;
    this.runOverwrite = false;
    this.snapshotDefer = null;
    this.tempImageData = null;

    this.layer = null;
    this.imageSave = null;
    this.groupSave = null;
    this.fileUploading = null;
    this.resizeImageData = null;
    this.imageDefer = null;
    this.drawCanvasDefer = null;

    this.canvasHeight = 0;
    this.canvasWidth = 0;

    this.cbData = null;
    this.cbOriginalData = null;
    this.cbImgData = null;
    this.cbImgData1 = null;
    this.cbChangeCtx = null;
    this.colorVal = 30;

    this.hueSlider = 180;
    this.satSlider = 180;
    this.lumSlider = 180;
    this.colorTest = '#ffffff';

    this.updatePreviewTimer = null;
    this.runningUpdate = false;

    this.inFormatMode = false;
    this.app.inCropMode = false;
    this.subscription = null;
    this.cardBackColor = "";

    this.app.backgroundColor = "#ffffff";
    this.app.imageChanged = false;
    this.app.selectedImage = null;
    this.app.clickPixelForColor = false;
    this.app.images = [];
    this.app.hasImageAdded = false;
  }

  setUpdatePreview(addBack = true) {
    this.clearUpdating();
    this.updatePreviewTimer = setTimeout(() => {
      if (!this.runningUpdate) {
        this.runningUpdate = true;
        // this.createPreviewImage(addBack);
      } else {
        this.setUpdatePreview();
      }
    }, 1000);
  }

  clearUpdating = () => {
    if (this.updatePreviewTimer != null) {
      clearTimeout(this.updatePreviewTimer);
      this.updatePreviewTimer = null;
    }
  }

  ngOnInit() {
    $('document').ready(() => {
      $('#fileUpload').on('change', (evt) => {
        if (this.app.selectedImage === null) {
          this.app.hasImageAdded = true;
          this.setupNewImage(this.app.creating.cardImage.length,  "image", '/assets/Blank Image.jpg', false, false,
            .5, .5, .25, .25, true);
          if (this.app.selectedImage !== null) {
            this.app.selectedImage.draggable = false;
          }
          this.app.selectedImage = this.app.creating.cardImage[this.app.creating.cardImage.length - 1];
          //Moved the item to the front
        }
        this.app.broadcast({event: 'hadImageAdded'});

        console.log("File upload event: ", evt);
        let reader = new FileReader();
        this.fileUploading = evt.target.files[0];
        reader.readAsDataURL(evt.target.files[0]);

        reader.onload = this.loaded;
      });
      $('#fileUpload').on('focus', (evt) => {
        // console.log("File upload blur");
      });
    });

    setTimeout(() => {
      // console.log("In canvas click timeout");
      let element = document.getElementById("container");
      if (element) {
        element.onclick = (e) => {
          console.log("On click");
          if (this.app.clickPixelForColor) {
            this.runGetPixelColor(e.layerX, e.layerY);
          }
        };
      }
    }, 500);
    this.getFontList();
    this.drawEditingCanvas();
    this.zone.run(() => {});
  }

  runGetPixelColor(posX: number, posY: number) {
    let element = document.getElementById("container");
    // console.log("Element click event: ", e);
    let cLeft = $('#container').offset().left;
    let cTop = $('#container').offset().top;
    console.log("Container Left: ", cLeft, " Top: ", cTop);
    let x = posX, y = posY;
    // console.log("Click position: ", e.clientX, e.clientY);
    console.log("Element Coordinate of click: ", x, y);
    this.app.clickPixelForColor = false;
    let canvas: any = element.children[0].children[0];
    console.log("Creating card: ", this.app.creating);
    console.log("Canvas: ", canvas.height, canvas.width);
    let pixelData = canvas.getContext('2d').getImageData(x, y, 1, 1).data;
    console.log("Pixel data: ", pixelData);
    if (pixelData.length >= 3) {
      if (pixelData[0] === 0 && pixelData[1] === 0 && pixelData[2] === 0) {
        return;
      }
      let hex = this.rgbToHex({r: pixelData[0], g: pixelData[1], b: pixelData[2]});
      // console.log("Hex: ", hex);
      this.cardBackColor = hex;
      this.cardBackColorSelChange();
    } else {
      this.cardBackColor = "#0000ff";
    }
  }

  ngOnDestroy() {}

  cardBackClicked(cardBack: CardBack) {
    console.log("Card back click: ", cardBack);
    cardBack.src = cardBack.origBack;
    cardBack.updatedBack = cardBack.origBack;
    this.setupColorWheels(cardBack);
    this.originalCard = cardBack;
    this.cbOriginalData = null;
    var prevWasBlank = this.app.creating.cardBack.id === 0;
    this.app.creating.cardBack = cardBack;
    this.setUpHolePosValues(cardBack.holes);
    this.createHolesInBack();
    this.colorTest = this.app.createClone(this.app.selectedCardBack.main);
    this.drawEditingCanvas();
    if (this.app.creating.cardBack.id !== 0) {
      this.app.broadcast({event: 'selectCutHolesTab'});
    }
    // this.setUpdatePreview();
  }

  templateClicked(template: Template) {
    console.log("Card back click: ", template);
    template.cardBack.src = template.cardBack.origBack;
    template.cardBack.updatedBack = template.cardBack.origBack;
    this.setupColorWheels(template.cardBack);
    this.originalCard = template.cardBack;
    this.cbOriginalData = null;
    var prevWasBlank = this.app.creating.cardBack.id === 0;
    this.app.creating.cardBack = template.cardBack;
    this.app.creating.cardHoles = template.cardBack.holes;
    if (this.app.selectedImage !== null) {
      this.app.selectedImage.resizable = false;
      this.app.selectedImage = null;
    }
    this.app.creating.cardImage.forEach((i) => {
      i.resizable = false;
    })
    this.app.creating.cardText.forEach((t) => {
      t.resizable = false;
    });
    this.setUpHolePosValues(this.app.creating.cardHoles);
    this.createHolesInBack();
    this.colorTest = this.app.createClone(this.app.selectedCardBack.main);
    this.app.creating.cardText = this.app.creating.cardText.filter((t) => {
      return !t.textSetup.templateText;
    })
    template.text.forEach((textImage) => {
      this.setImageVals(textImage);
      this.app.creating.cardText.push(textImage);
    });
    this.drawEditingCanvas();
    if (this.app.creating.cardBack.id !== 0) {
      this.app.broadcast({event: 'selectCutHolesTab'});
    }
  }

  setUpHolePosValues(holes: CardHole[]) {
    holes.forEach((h) => {
      this.setHoleVals(h);
    });
  }

  setHoleVals(h: CardHole) {
    if (this.canvasWidth === 0 && this.canvasHeight === 0) {
      return;
    }
    h.hadValsSet = true;
    h.xPos = this.canvasWidth * (h.x / 100);
    h.yPos = this.canvasHeight * (h.y / 100);
    h.wPos = this.canvasWidth * (h.width / 100);
    h.hPos = this.canvasHeight * (h.height / 100);
  }

  setUpImagePosValues(images: CardImage[]) {
    images.forEach((h) => {
      this.setImageVals(h);
    });
  }

  setImageVals(h: CardImage) {
    if (this.canvasHeight === 0 || this.canvasWidth === 0) return;
    h.hadValsSet = true;
    h.xPos = this.canvasWidth * (h.x / 100);
    h.yPos = this.canvasHeight * (h.y / 100);
    h.wPos = (this.canvasWidth * (h.width / 100)) + (h.type === ImageType.text ? (h.textSetup.extraWidth + h.textSetup.borderWidth * 2) : 0);
    h.hPos = (this.canvasHeight * (h.height / 100)) + (h.type === ImageType.text ? (h.textSetup.extraHeight + h.textSetup.borderWidth * 2) : 0);
    h.aspectRatio = h.hPos / h.wPos;
  }

  setupColorWheels(cardBack: CardBack) {
    // console.log("Update color wheel");
    if (cardBack.hwheel.length === 0 || cardBack.updateWheels) {
      // console.log("In update");
      cardBack.hwheel = [];
      cardBack.swheel = [];
      cardBack.lwheel = [];
      this.cardBackColor = cardBack.main;
      let rgb = this.hexToRgb(cardBack.main);
      let hsl = this.rgbToHsl(rgb.r, rgb.g, rgb.b);

      let hue = hsl.h * 240;
      let sat = hsl.s * 240;
      let lum = hsl.l * 240;
      cardBack.hue = hue;
      cardBack.saturation = sat;
      cardBack.luminosity = lum;

      if (cardBack.updateWheels) {
        hsl.h = this.hueSlider / 240;
      }

      for (let i = 0; i <= 360; i = i + 10) {
        let hRgb = this.hslToRgb(i / 360, 1, .5); //Hardcoded the s,l values to visible colors on hue slider
        let hhex = this.rgbToHex(hRgb);
        cardBack.hwheel.push(hhex);

        let sRgb = this.hslToRgb(hsl.h, i / 360, .5); //Hardcoded the s,l values to visible colors on hue slider
        let shex = this.rgbToHex(sRgb);
        cardBack.swheel.push(shex);

        let lRgb = this.hslToRgb(hsl.h, 1, i / 360); //Hardcoded the s,l values to visible colors on hue slider
        let lhex = this.rgbToHex(lRgb);
        cardBack.lwheel.push(lhex);
      }
      // if (!cardBack.updateWheels) {
      this.hueSlider = Math.floor(hue);
      this.satSlider = Math.floor(sat);
      this.lumSlider = Math.floor(lum);
      // }
      cardBack.updateWheels = false;
    }
  }

  getPreviewButtonText() {
    if (this.app.hasImageAdded) {
      if (this.app.viewMode === 1) {
        return "Save";
      } else {
        return "Preview";
      }
    } else {
      return "Saved Cards";
    }
  }

  changeViewMode(mode: number) {
    console.log("Change view mode: ", mode);
    console.log("Window height: ", window.innerHeight, " Window Width: ", window.innerWidth);
    if (!this.app.hasImageAdded && mode === 1) {
      this.app.viewMode = 1;
      this.app.showReady = true;
      this.goToManageCards();
      return;
    }
    if (mode === 1 && this.app.viewMode === 1) {
      if (this.app.creating.cardBack.id !== 0 && this.app.creating.cardHoles.length > 0
        && this.app.creating.cardHoles[0].type !== HoleType.none) {
        this.readyClicked();
        return;
      } else {
        this.app.viewMode = mode;
        this.app.showReady = true;
        return;
      }
    }
    this.app.viewMode = mode;
    if (mode === 1) {
      this.makeSnapshot();
    } else {

    }
  }

  getViewModeButtonDesign(mode: number) {
    if (this.app.viewMode === mode) {
      return {'background-color': '#EEE1B7'};
    }
    return {};
  }

  hexToRgb(color) {
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    color = color.replace(shorthandRegex, (m, r, g, b) => {
      return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : {
      r: 0,
      g: 0,
      b: 0
    };
  }

  componentToHex(c) {
    let hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  rgbToHex(rgb) {
    return "#" + this.componentToHex(rgb.r) + this.componentToHex(rgb.g) + this.componentToHex(rgb.b);
  }

  cardBackColorSelChange() {
    // console.log("Card back color change: ", this.cardBackColor);
    let rgb = this.hexToRgb(this.cardBackColor);
    // console.log("RGB: ", rgb);
    let hsl = this.rgbToHsl(rgb.r, rgb.g, rgb.b);
    // console.log("HSL: ", hsl);
    this.hueSlider = hsl.h * 240;
    this.satSlider = hsl.s * 240;
    this.lumSlider = (hsl.l * 240) < 60 ? 60 : ((hsl.l * 240) > 230 ? 230 : (hsl.l * 240));
    this.hslChange(1);
  }

  hslChange = (type: number = 0) => {
    console.log("Hsl changed: ", this.hueSlider, this.satSlider, this.lumSlider);
    this.changeHsl(type, this.hueSlider / 240, this.satSlider / 240, this.lumSlider / 240);
    // this.setupColorWheels(this.app.selectedCardBack);  //Uncommented for removing slider change
    // this.drawEditingCanvas();
  };

  changeHSL(type, canvas, hShift, sShift, lShift) {
    let count = 0;
    let prev = null;
    let origrgb = this.hexToRgb(this.app.creating.cardBack.main);
    let orighsl = this.rgbToHsl(origrgb.r, origrgb.g, origrgb.b);
    for(let i = 0; i < this.cbData.length; i += 4) {
      let red = this.cbOriginalData[i];
      let green = this.cbOriginalData[i+1];
      let blue = this.cbOriginalData[i+2];
      let alpha = this.cbOriginalData[i+3];

      if(alpha<230){continue;}

      let hsl = this.rgbToHsl(red,green,blue);
      let newRgb = null;


      let newL = (hsl.l * 240) > 230 ? hsl.l : ((hsl.l / orighsl.l) * lShift);

      newRgb = this.hslToRgb(hShift, sShift, newL);

      this.cbData[i] = newRgb.r;
      this.cbData[i+1] = newRgb.g;
      this.cbData[i+2] = newRgb.b;
      this.cbData[i+3] = 255;
    }
    this.cbChangeCtx.putImageData(this.cbImgData,0,0);
    return canvas.toDataURL("image/png", 1);
  }

  hslShift(type, canvas, hShift, sShift, lShift){
    //THIS IS HERE FOR THE NEW COLOR CHANGE, NO SLIDERS
    return this.changeHSL(type, canvas, hShift, sShift, lShift);
  }

  changeHsl(type, hue, sat, lum) {
    // console.log("Change hsl: ", hue, sat, lum);
    let tempList = [];
    // console.log("After first draw preview canvas");
    setTimeout(() => {
      // console.log("Inside of timeout");
      let canvas: any = document.getElementById("cardBackColorChanger");
      let ctx = canvas.getContext('2d');
      this.cbChangeCtx = ctx;
      let image = new Image();
      image.onload = () => {
        // console.log("Image loaded");
        // image = this.colorImage(image, '#00ff00');
        let cw = canvas.width = image.width;
        let ch = canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        this.cbImgData = ctx.getImageData(0,0,cw,ch);
        this.cbData = this.cbImgData.data;
        this.cbImgData1 = ctx.getImageData(0,0,cw,ch);
        if (type === 0 || this.cbOriginalData === null) {
          // console.log("Update original data");
          this.cbOriginalData = this.cbImgData1.data;
        }
        this.colorVal = this.colorVal + 10;
        this.app.creating.cardBack.updateWheels = true;
        this.app.creating.cardBack.updatedBack = this.hslShift(type, canvas, hue, sat, lum);
        canvas.height = 0;
        canvas.width = 0;
        ctx.restore();

        this.createHolesInBack();
        setTimeout(() => {
          this.drawEditingCanvas();
        }, 500);
      };
      image.src = this.app.creating.cardBack.origBack;
    }, 500);
  }

  createHolesInBack = () => {
    console.log("Create holes in back");
    var cardBack = this.app.creating.cardBack.updatedBack;
    this.cuttingHoleDefer(0, cardBack);
    return;
  }

  cuttingHoleDefer = (index: number, cardBack: string) => {
    if (this.app.creating.cardHoles.length > index) {
      var hole: CardHole = this.app.creating.cardHoles[index];
      if (!hole.hadValsSet) this.setHoleVals(hole);
      this.startCutHole(index, hole, cardBack);
    } else {
      this.app.creating.cardBack.holedBack = cardBack;
      this.drawHoleBorders();
    }
  };

  startCutHole = (index: number, h: CardHole, back: string) => {
    let canvas: any = document.getElementById('holeCutter');
    // canvas.restore();
    canvas.width = this.canvasWidth;
    canvas.height = this.canvasHeight;
    let context: any = canvas.getContext('2d');
    context.restore();
    context.width = this.canvasWidth;
    context.height = this.canvasHeight;
    let imageObj = new Image();
    imageObj.onload = () => {
      let destWidth = this.canvasWidth;
      let destHeight = this.canvasHeight;
      let ratioX = imageObj.width / this.canvasWidth;
      let ratioY = imageObj.height / this.canvasHeight;
      let width = this.canvasWidth * ratioX;
      let height = this.canvasHeight * ratioY;
      context.drawImage(imageObj, 0, 0, width, height, 0, 0, destWidth, destHeight);
      if (h.type !== HoleType.none) {
        this.cutter.cutHole(h, context, this.canvasWidth, this.canvasHeight);
      }
      this.cuttingHoleDefer(index + 1, canvas.toDataURL('image/png', 1));
    };
    imageObj.src = back;
  };

  drawHoleBorders() {
    let canvas: any = document.getElementById('holeCutter');
    // canvas.restore();
    canvas.width = this.canvasWidth;
    canvas.height = this.canvasHeight;
    let context: any = canvas.getContext('2d');
    context.restore();
    context.width = this.canvasWidth;
    context.height = this.canvasHeight;
    let imageObj = new Image();
    imageObj.onload = () => {
      let destWidth = this.canvasWidth;
      let destHeight = this.canvasHeight;
      let destX = 0;
      let destY = 0;
      let ratioX = imageObj.width / this.canvasWidth;
      let ratioY = imageObj.height / this.canvasHeight;
      let width = this.canvasWidth * ratioX;
      let height = this.canvasHeight * ratioY;
      context.drawImage(imageObj, 0, 0, width, height, 0, 0, destWidth, destHeight);
      this.app.creating.cardHoles.forEach((h: CardHole) => {
        if (h.type !== HoleType.none) {
          this.drawBorder(h, context);
        }
      });
      this.app.creating.cardBack.holedBack = canvas.toDataURL('image/png', 1);
      // this.drawEditingCanvas();
    };
    imageObj.src = this.app.creating.cardBack.holedBack;
  }

  drawBorder(h: CardHole, ctx: any) {
    ctx.lineWidth = h.borderWidth;
    ctx.strokeStyle = h.borderColor;
    switch(h.type) {
      case HoleType.circle:
        this.drawCircleBorder(h, ctx);
        break;
      case HoleType.square:
        this.drawSquareBorder(h, ctx);
        break;
      case HoleType.diamond:
        this.drawDiamondBorder(h, ctx);
        break;
      case HoleType.triangle:
        this.drawTriangleBorder(h, ctx);
        break;
      case HoleType.heart:
        this.drawHeartBorder(h, ctx);
        break;
      case HoleType.club:
        this.drawClubBorder(h, ctx);
        break;
      case HoleType.spade:
        this.drawSpadeBorder(h, ctx);
        break;
      case HoleType.star:
        this.drawStarBorder(h, ctx);
        break;
      default: //Nothing to do here
        return;
    }
  }

  drawSquareBorder(h: CardHole, ctx: any) {
    ctx.strokeRect(h.xPos - (h.borderWidth / 2), h.yPos - (h.borderWidth / 2), h.wPos + h.borderWidth, h.hPos + (h.borderWidth));
  }

  drawCircleBorder(hole: CardHole, ctx: any) {
    ctx.beginPath();
    ctx.ellipse(hole.xPos + (hole.wPos / 2), hole.yPos + (hole.hPos / 2),
      (hole.wPos / 2) + (hole.borderWidth / 2), (hole.hPos / 2) + (hole.borderWidth / 2), Math.PI, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.stroke();
  }

  drawDiamondBorder(hole: CardHole, ctx: any) {
    ctx.beginPath();
    ctx.moveTo(hole.xPos + (hole.wPos / 2), hole.yPos - (hole.borderWidth / 2));
    ctx.lineTo(hole.xPos + hole.wPos + (hole.borderWidth / 2), hole.yPos + (hole.hPos / 2));
    ctx.lineTo(hole.xPos + (hole.wPos / 2),hole.yPos + hole.hPos + (hole.borderWidth / 2));
    ctx.lineTo(hole.xPos - (hole.borderWidth / 2), hole.yPos + (hole.hPos / 2));
    ctx.closePath();
    ctx.stroke();
  }

  drawHeartBorder(hole: CardHole, ctx: any) {
    ctx.beginPath();
    var x = hole.xPos;
    var y = hole.yPos;
    ctx.moveTo(x + (hole.wPos * (75/150)), y + (hole.hPos * (30/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (75/150)), y + (hole.hPos * (30/150)),
      x + (hole.wPos * (65/150)), y + (hole.hPos * (0/150)),
      x + (hole.wPos * (40/150)), y + (hole.hPos * (0/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (0/150)), y + (hole.hPos * (0/150)),
      x + (hole.wPos * (0/150)), y + (hole.hPos * (50/150)),
      x + (hole.wPos * (0/150)), y + (hole.hPos * (50/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (0/150)), y + (hole.hPos * (80/150)),
      x + (hole.wPos * (35/150)),y + (hole.hPos * (115/150)),
      x + (hole.wPos * (75/150)), y + (hole.hPos * (150/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (125/150)), y + (hole.hPos * (115/150)),
      x + (hole.wPos * (150/150)), y + (hole.hPos * (80/150)),
      x + (hole.wPos * (150/150)), y + (hole.hPos * (50/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (150/150)), y + (hole.hPos * (50/150)),
      x + (hole.wPos * (150/150)), y + (hole.hPos * (0/150)),
      x + (hole.wPos * (115/150)), y + (hole.hPos * (0/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (85/150)), y + (hole.hPos * (0/150)),
      x + (hole.wPos * (75/150)), y + (hole.hPos * (30/150)),
      x + (hole.wPos * (75/150)), y + (hole.hPos * (30/150)));
    ctx.closePath();
    ctx.stroke();
  }

  drawClubBorder(hole: CardHole, ctx: any) {
    var x = hole.xPos + (hole.wPos / 2);
    var y = hole.yPos;
    var height = hole.hPos;
    var width = hole.wPos;
    var circleRadiusX = hole.wPos * 0.3;
    var circleRadiusY = hole.hPos * 0.2;
    var bottomWidth = hole.wPos * 0.5;
    var bottomHeight = hole.hPos * 0.35;
    ctx.beginPath();
    ctx.ellipse(
      x, y + (hole.hPos * 0.30),
      circleRadiusX, circleRadiusY, 0, .85 * Math.PI, 2.15 * Math.PI, false
    );
    ctx.ellipse(
      x + (hole.wPos * 0.25), y + (height * 0.6),
      circleRadiusX, circleRadiusY, 0, 1.5 * Math.PI, 2.8 * Math.PI, false
    );
    ctx.ellipse(
      x - (hole.wPos * 0.25), y + (height * 0.6),
      circleRadiusX, circleRadiusY, 0, .75, 1.5 * Math.PI, false
    );
    ctx.closePath();

    ctx.moveTo(x, y + (height * 0.7));
    ctx.quadraticCurveTo(
      x, y + (height),
      x - bottomWidth / 2, y + (height)
    );
    ctx.lineTo(x + bottomWidth / 2, y + height);
    ctx.quadraticCurveTo(
      x, y + (height),
      x, y + (height * 0.7)
    );
    ctx.closePath();
    ctx.stroke();
  }

  drawSpadeBorder(hole: CardHole, ctx: any) {
    var width = hole.wPos;
    var height = hole.hPos;
    var x = hole.xPos + (hole.wPos / 2);
    var y = hole.yPos;
    var bottomWidth = width * 0.7;
    var topHeight = height * 0.7;
    var bottomHeight = height * 0.3;
    ctx.beginPath();
    ctx.moveTo(x, y);

    // top left of spade
    ctx.bezierCurveTo(
      x, y + topHeight / 2, // control point 1
      x - width / 2, y + topHeight / 2, // control point 2
      x - width / 2, y + topHeight // end point
    );

    // bottom left of spade
    ctx.bezierCurveTo(
      x - width / 2, y + topHeight * 1.3, // control point 1
      x, y + topHeight * 1.3, // control point 2
      x, y + topHeight // end point
    );

    // bottom right of spade
    ctx.bezierCurveTo(
      x, y + topHeight * 1.3, // control point 1
      x + width / 2, y + topHeight * 1.3, // control point 2
      x + width / 2, y + topHeight // end point
    );

    // top right of spade
    ctx.bezierCurveTo(
      x + width / 2, y + topHeight / 2, // control point 1
      x, y + topHeight / 2, // control point 2
      x, y // end point
    );
    ctx.closePath();

    ctx.moveTo(x, y + topHeight);
    ctx.quadraticCurveTo(
      x, y + topHeight + bottomHeight, // control point
      x - bottomWidth / 2, y + topHeight + bottomHeight // end point
    );
    ctx.lineTo(x + bottomWidth / 2, y + topHeight + bottomHeight);
    ctx.quadraticCurveTo(
      x, y + topHeight + bottomHeight, // control point
      x, y + topHeight // end point
    );
    ctx.closePath();
    ctx.stroke();
  }

  drawStarBorder(hole: CardHole, ctx: any) {
    var points = [ [ 0, 85 ], [ 75, 75 ], [ 100, 10 ], [ 125, 75 ],
      [ 200, 85 ], [ 150, 125 ], [ 160, 190 ], [ 100, 150 ],
      [ 40, 190 ], [ 50, 125 ], [ 0, 85 ] ];

    var len = points.length;

    ctx.moveTo(hole.xPos + (hole.wPos * (points[0][0] / 190)), hole.yPos + (hole.hPos * (points[0][1] / 190)));

    ctx.beginPath();
    for (var i = 0; i < len; i++) {
      ctx.lineTo(hole.xPos + (hole.wPos * (points[i][0] / 190)), hole.yPos + (hole.hPos * (points[i][1] / 190)));
    }
    ctx.closePath();
    ctx.stroke();
  }

  drawTriangleBorder(hole: CardHole, ctx: any) {
    ctx.beginPath();
    ctx.moveTo(hole.xPos + (hole.wPos / 2), hole.yPos + (hole.borderWidth / 2));
    ctx.lineTo(hole.xPos + hole.wPos - (hole.borderWidth / 2), hole.yPos + hole.hPos - (hole.borderWidth / 2));
    ctx.lineTo(hole.xPos + (hole.borderWidth / 2),hole.yPos + hole.hPos - (hole.borderWidth / 2));
    ctx.closePath();
    ctx.stroke();
  }

  finishSetCardBack() {

  }

  drawEditingCanvas = () => {
    console.log("Draw editing canvas");
    if (this.app.showIntro) return;

    // if (this.stage !== null) {
    //   this.stage.clearCache();
    // }
    // this.stage = new Konva.Stage({
    //   container: 'container',
    //   width: this.canvasWidth,
    //   height: this.canvasHeight
    // });
    // this.layer = new Konva.Layer();
    // this.stage.add(this.layer);

    if (!this.hasMadeStage) {
      console.log("Adding stage", this.canvasWidth, this.canvasHeight);
      this.stage = new Konva.Stage({
        container: 'container',
        width: this.canvasWidth,
        height: this.canvasHeight
      });
      this.hasMadeStage = true;
      this.layer = new Konva.Layer();
      this.stage.add(this.layer);
    } else {
      console.log("Already added stage", this.canvasWidth, this.canvasHeight);
      this.stage.clearCache();
      // this.layer = new Konva.Layer();
      this.stage.setAttrs({
        width: this.canvasWidth,
        height: this.canvasHeight
      });
      this.layer.clearCache();
      this.layer.removeChildren();
      this.stage.add(this.layer);
    }
    this.setUpEditingCard(this.stage, this.layer);
  }

  setUpEditingCard(stage: any, layer: any) {
    console.log("Set up editing card", this.app.creating, this.app.selectedImage);
    this.app.creating.cardImage.forEach((i: CardImage) => {
      if (!i.hadValsSet) this.setImageVals(i);
      this.createNewImage(i, i.src, this.app.selectedImage && this.app.selectedImage.id === i.id,
        this.app.selectedImage && this.app.selectedImage.id === i.id, i.wPos, i.hPos, i.xPos, i.yPos, layer);
      if(this.app.selectedImage && this.app.selectedImage.id === i.id && this.app.selectedImage.type === ImageType.image) {
        console.log("Adding anchors");
        this.finishAddAnchors(i, i.wPos, i.hPos, this.app.inCropMode);
      } else {
        i.groupSave.removeChildren();
        i.groupSave.add(i.imageSave);
      }
    });
    // if (this.app.creating.cardBack !== null) {
    //   this.drawCardBack(this.app.creating.cardBack);
    // }
    this.app.creating.cardText.forEach((i: CardImage) => {
      if (!i.hadValsSet) this.setImageVals(i);
      this.createTextImage(i, layer);
      if(this.app.selectedImage && i.resizable && this.app.selectedImage.id === i.id && this.app.selectedImage.type === ImageType.text) {
        console.log("Add crop anchors");
        this.finishAddAnchors(i, i.wPos, i.hPos, false);
      } else {
        i.groupSave.removeChildren();
        i.groupSave.add(i.imageSave);
      }
    });
    this.app.creating.cardHoles.forEach((h: CardHole) => {
      if (!h.hadValsSet) this.setHoleVals(h);
      if (h.resizing) {
        this.formatter.canvasWidth = this.canvasWidth;
        this.formatter.canvasHeight = this.canvasHeight;
        this.formatter.isMobile = this.app.isMobile;
        this.formatter.setUpHoleForResizing(stage, layer, h, this.clearUpdating, this.cardHoleResized, this.holeTapped);
      }
    });
    setTimeout(() => {
      this.makeSnapshot();
    }, 1000);
  }

  tapIsInImage(x, y, i: CardImage): boolean {
    return i.xPos < x && x < (i.wPos + i.xPos) && i.yPos < y && y < (i.hPos + i.yPos);
  }

  findImageWithTap(x: number, y: number): CardImage {
    var image: CardImage = null;
    console.log("Images: ", this.app.creating.cardImage);
    for (var i = 0; i < this.app.creating.cardImage.length; i++) {
      if (this.tapIsInImage(x, y, this.app.creating.cardImage[i])) {
        return this.app.creating.cardImage[i];
      }
    }
    for (var j = 0; j < this.app.creating.cardText.length; j++) {
      if (this.tapIsInImage(x, y, this.app.creating.cardText[j])) {
        return this.app.creating.cardText[j];
      }
    }
    return image;
  }

  holeTapped = (e) => {
    this.imageTap(e, this.app.creating.cardImage.length > 0 ? this.app.creating.cardImage[0] : null);
  };

  imageTap = (e, image) => {
    console.log("Pos: ", e.currentTarget.pointerPos);
    console.log("Target: ", e.currentTarget);
    console.log("EVT: ", e.evt);
    console.log("Checking that we are here");
    console.log("Tapped image: ", image);
    if (this.app.clickPixelForColor) {
      if (e.evt !== undefined && e.evt.changedTouches !== undefined && e.evt.changedTouches.length > 0) {
        let element = document.getElementById("container");
        let canvas: any = element.children[0].children[0];
        let x = e.evt.changedTouches[0].clientX - $('#container').offset().left;
        let y = e.evt.changedTouches[0].clientY - $('#container').offset().top;
        var width = $('#container').width();
        var height = $('#container').height();
        this.runGetPixelColor((x / width) * canvas.width, (y / height) * canvas.height);
        return;
      }
    }
    var hadResizing = false;
    this.app.creating.cardHoles.forEach((h) => {
      hadResizing = h.resizing ? true : hadResizing;
      h.resizing = false;
    });
    if (image !== null && (this.app.selectedImage === null || (image.id !== this.app.selectedImage.id
        || image.type !== this.app.selectedImage.type))) {
      // console.log("Here: ", this.app.creating);
      this.app.creating.cardImage.forEach((t) => {
        t.resizable = false;
      });
      this.app.creating.cardText.forEach((t) => {
        t.resizable = false;
      });
      this.app.selectedImage = image.type === ImageType.image ? this.app.creating.cardImage[0] : image;
      this.app.selectedImage.resizable = true;
      hadResizing = true;
    }
    if (hadResizing) {
      this.createHolesInBack();
      this.drawEditingCanvas();
    }
    return;
  }

  cardHoleResized = () => {
    this.createHolesInBack();
    setTimeout(() => {
      this.makeSnapshot();
    }, 500);
  }

  setupEditor(stage: any, layer: any, images: any = null, addAnchors = true) {

  }

  loaded = (evt) => {
    let originalFile = evt.target.result;
    // console.log("File uploading: ", this.fileUploading);
    this.getOrientation(this.fileUploading, (orientation) => {
      this.orientationResult(orientation, originalFile);
    });
  };

  orientationResult = (orientation, origFile) => {
    // console.log("Orientation: ", orientation);
    if (origFile) {
      origFile = origFile.replace(this.fileUploading.type, '');
      this.imageDefer = () => {
        this.runImageDefer();
        this.imageDefer = null;
      };
      this.resizeImage(origFile, this.canvasWidth, this.canvasHeight);
    }
  };

  runImageDefer() {
    this.drawEditingCanvas();
    // this.drawPreviewCanvas();
    // this.setUpdatePreview();
  }

  resizeImage(imageSrc, maxWidth, maxHeight) {
    console.log("RESIZE IMAGE: ", imageSrc);

    let image = new Image();
    image.crossOrigin = "Anonymous";
    image.onload = () => {
      let canvas = document.createElement("canvas");
      canvas.style.display="none";
      document.body.appendChild(canvas);

      if (image.width > maxWidth || image.height > maxHeight) {
        if (image.width >= image.height) {
          //landscape
          canvas.width = maxWidth;
          canvas.height = maxWidth * (image.height / image.width);
        } else {
          canvas.height = maxHeight;
          canvas.width = maxHeight * (image.width / image.height);
        }
      } else {
        canvas.width = image.width;
        canvas.height = image.height;
      }

      let ratioH = 1;
      let ratioW = 1;
      if (image.width > canvas.width) {
        ratioW = canvas.width / image.width;
      }
      if(image.height > canvas.height) {
        ratioH = canvas.height / image.height;
      }
      let ratio = ratioH < ratioW ? ratioH : ratioW;

      let context = canvas.getContext("2d");
      let wh = this.getCanvasWidthAndHeight();
      this.app.selectedImage.height = (((image.height * (ratio * .75))) / wh.h) * 100;
      this.app.selectedImage.width = (((image.width * (ratio * .75))) / wh.w) * 100;
      this.app.selectedImage.aspectRatio = this.app.selectedImage.height / this.app.selectedImage.width;
      this.app.selectedImage.x = (100 - this.app.selectedImage.width) / 2;
      this.app.selectedImage.y = (100 - this.app.selectedImage.height) / 2;
      this.setImageVals(this.app.selectedImage);
      // console.log("Selected image: ", this.app.createClone(this.app.selectedImage));
      console.log("Selected image curr: ", this.app.selectedImage);
      context.scale(ratio, ratio);
      this.app.selectedImage.hasLink = false;
      context.drawImage(image, 0, 0);

      this.app.selectedImage.src = canvas.toDataURL("image/png", 1);

      document.body.removeChild(canvas);
      setTimeout(() => {
        $('#canvasContainer').click();
      });

      this.runImageDefer();
    };
    image.src = imageSrc;
  }

  addImage() {
    this.editingImage = false;
    this.app.selectedImage = null;
    $('#fileUpload').click();
  }

  editImage() {
    this.editingImage = true;
    $('#fileUpload').click();
  }

  deleteImage() {

  }

  cropImageToFrame() {

  }

  startCropImage(type: number) {
    this.app.selectedImage.draggable = true;
    this.app.selectedImage.resizable = true;
    this.app.inCropMode = true;
    this.app.cropShape = type;
    this.drawEditingCanvas();
  }

  acceptCircleCropImage() {
    console.log("Accept circle crop image");
    if (this.app.creating.cardHoles.length === 0) {
      console.log("No Card Holes");
      return;
    } //Card card hole to crop to
    let canvas: any = document.getElementById('imageCropper');
    if ((this.app.selectedImage === null || this.app.selectedImage === undefined) && this.app.creating.cardImage.length > 0) {
      this.app.selectedImage = this.app.creating.cardImage[0];
    }
    var h: CardHole = this.app.creating.cardHoles[0];

    canvas.width = h.wPos;
    canvas.height = h.hPos;
    // console.log("Canvas: ", canvas);
    let context: any = canvas.getContext('2d');
    context.width = h.wPos;
    context.height = h.hPos;
    // console.log("Context: ", context);
    let imageObj = new Image();

    imageObj.onload = () => {
      var wt = h.wPos;
      var ht = h.hPos;
      var xDif = h.xPos;
      var yDif = h.yPos;
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.beginPath();
      context.ellipse((wt / 2), (ht / 2), wt / 2, ht / 2, Math.PI, 0, 2 * Math.PI);
      context.clip();
      context.drawImage(imageObj, this.app.selectedImage.xPos - h.xPos, this.app.selectedImage.yPos - h.yPos,
        this.app.selectedImage.wPos, this.app.selectedImage.hPos);

      this.app.selectedImage.src = canvas.toDataURL('image/png', 1);
      this.app.selectedImage.wPos = h.wPos;
      this.app.selectedImage.hPos = h.hPos;
      this.app.selectedImage.xPos = h.xPos;
      this.app.selectedImage.yPos = h.yPos;
      this.setHolePositionToImage();
      this.app.selectedImage.groupSave.removeChildren();
      this.app.selectedImage.groupSave.add(this.app.selectedImage.imageSave);
      this.app.inCropMode = false;
      this.createHolesInBack();
      this.drawEditingCanvas();
    };
    imageObj.src = this.app.selectedImage.src;
  }

  acceptSquareCropImage = () => {
    console.log("Accept square crop image", this.app.creating);
    if (this.app.creating.cardHoles.length === 0) {
      console.log("No Card Holes");
      return;
    } //Card card hole to crop to

    let canvas: any = document.getElementById('imageCropper');
    if ((this.app.selectedImage === null || this.app.selectedImage === undefined) && this.app.creating.cardImage.length > 0) {
      this.app.selectedImage = this.app.creating.cardImage[0];
    }
    var h: CardHole = this.app.creating.cardHoles[0];

    canvas.width = h.wPos;
    canvas.height = h.hPos;
    let context: any = canvas.getContext('2d');
    context.width = h.wPos;
    context.height = h.hPos;
    let imageObj = new Image();

    imageObj.onload = () => {
      console.log("In onload");
      context.drawImage(imageObj, (h.xPos - this.app.selectedImage.xPos) * -1,
        (h.yPos - this.app.selectedImage.yPos) * -1,
        this.app.selectedImage.wPos, this.app.selectedImage.hPos);
      this.app.selectedImage.src = canvas.toDataURL('image/png', 1);
      this.app.selectedImage.wPos = h.wPos;
      this.app.selectedImage.hPos = h.hPos;
      this.app.selectedImage.xPos = h.xPos;
      this.app.selectedImage.yPos = h.yPos;
      this.setHolePositionToImage();
      this.app.selectedImage.groupSave.removeChildren();
      this.app.selectedImage.groupSave.add(this.app.selectedImage.imageSave);
      this.app.inCropMode = false;
      this.createHolesInBack();
      this.drawEditingCanvas();
      console.log("Here at this point");
    };
    imageObj.src = this.app.selectedImage.src;
  }

  acceptDiamondCropImage() {
    console.log("Accept circle crop image");
    if (this.app.creating.cardHoles.length === 0) {
      console.log("No Card Holes");
      return;
    } //Card card hole to crop to
    let canvas: any = document.getElementById('imageCropper');
    if ((this.app.selectedImage === null || this.app.selectedImage === undefined) && this.app.creating.cardImage.length > 0) {
      this.app.selectedImage = this.app.creating.cardImage[0];
    }
    var h: CardHole = this.app.creating.cardHoles[0];

    canvas.width = h.wPos;
    canvas.height = h.hPos;
    // console.log("Canvas: ", canvas);
    let context: any = canvas.getContext('2d');
    context.width = h.wPos;
    context.height = h.hPos;
    // console.log("Context: ", context);
    let imageObj = new Image();

    imageObj.onload = () => {
      var wt = h.wPos;
      var ht = h.hPos;
      var xDif = h.xPos;
      var yDif = h.yPos;
      context.clearRect(0, 0, canvas.width, canvas.height);
      var tempH = new CardHole(-1, 0, 0, h.width, h.height, h.resizing, h.type, false);
      this.setHoleVals(tempH);
      this.cutter.clipDiamond(tempH, context);
      context.clip();
      context.drawImage(imageObj, this.app.selectedImage.xPos - h.xPos, this.app.selectedImage.yPos - h.yPos,
        this.app.selectedImage.wPos, this.app.selectedImage.hPos);

      this.app.selectedImage.src = canvas.toDataURL('image/png', 1);
      this.app.selectedImage.wPos = h.wPos;
      this.app.selectedImage.hPos = h.hPos;
      this.app.selectedImage.xPos = h.xPos;
      this.app.selectedImage.yPos = h.yPos;
      this.setHolePositionToImage();
      this.app.selectedImage.groupSave.removeChildren();
      this.app.selectedImage.groupSave.add(this.app.selectedImage.imageSave);
      this.app.inCropMode = false;
      this.createHolesInBack();
      this.drawEditingCanvas();
    };
    imageObj.src = this.app.selectedImage.src;
  }

  acceptSpadeCropImage() {
    console.log("Accept circle crop image");
    if (this.app.creating.cardHoles.length === 0) {
      console.log("No Card Holes");
      return;
    } //Card card hole to crop to
    let canvas: any = document.getElementById('imageCropper');
    if ((this.app.selectedImage === null || this.app.selectedImage === undefined) && this.app.creating.cardImage.length > 0) {
      this.app.selectedImage = this.app.creating.cardImage[0];
    }
    var h: CardHole = this.app.creating.cardHoles[0];

    canvas.width = h.wPos;
    canvas.height = h.hPos;
    // console.log("Canvas: ", canvas);
    let context: any = canvas.getContext('2d');
    context.width = h.wPos;
    context.height = h.hPos;
    // console.log("Context: ", context);
    let imageObj = new Image();

    imageObj.onload = () => {
      var wt = h.wPos;
      var ht = h.hPos;
      var xDif = h.xPos;
      var yDif = h.yPos;
      context.clearRect(0, 0, canvas.width, canvas.height);
      var tempH = new CardHole(-1, 0, 0, h.width, h.height, h.resizing, h.type, false);
      this.setHoleVals(tempH);
      this.cutter.clipSpade(tempH, context);
      context.clip();
      context.drawImage(imageObj, this.app.selectedImage.xPos - h.xPos, this.app.selectedImage.yPos - h.yPos,
        this.app.selectedImage.wPos, this.app.selectedImage.hPos);

      this.app.selectedImage.src = canvas.toDataURL('image/png', 1);
      this.app.selectedImage.wPos = h.wPos;
      this.app.selectedImage.hPos = h.hPos;
      this.app.selectedImage.xPos = h.xPos;
      this.app.selectedImage.yPos = h.yPos;
      this.setHolePositionToImage();
      this.app.selectedImage.groupSave.removeChildren();
      this.app.selectedImage.groupSave.add(this.app.selectedImage.imageSave);
      this.app.inCropMode = false;
      this.createHolesInBack();
      this.drawEditingCanvas();
    };
    imageObj.src = this.app.selectedImage.src;
  }

  acceptClubCropImage() {
    console.log("Accept circle crop image");
    if (this.app.creating.cardHoles.length === 0) {
      console.log("No Card Holes");
      return;
    } //Card card hole to crop to
    let canvas: any = document.getElementById('imageCropper');
    if ((this.app.selectedImage === null || this.app.selectedImage === undefined) && this.app.creating.cardImage.length > 0) {
      this.app.selectedImage = this.app.creating.cardImage[0];
    }
    var h: CardHole = this.app.creating.cardHoles[0];

    canvas.width = h.wPos;
    canvas.height = h.hPos;
    // console.log("Canvas: ", canvas);
    let context: any = canvas.getContext('2d');
    context.width = h.wPos;
    context.height = h.hPos;
    // console.log("Context: ", context);
    let imageObj = new Image();

    imageObj.onload = () => {
      var wt = h.wPos;
      var ht = h.hPos;
      var xDif = h.xPos;
      var yDif = h.yPos;
      context.clearRect(0, 0, canvas.width, canvas.height);
      var tempH = new CardHole(-1, 0, 0, h.width, h.height, h.resizing, h.type, false);
      this.setHoleVals(tempH);
      this.cutter.clipClub(tempH, context);
      context.clip();
      context.drawImage(imageObj, this.app.selectedImage.xPos - h.xPos, this.app.selectedImage.yPos - h.yPos,
        this.app.selectedImage.wPos, this.app.selectedImage.hPos);

      this.app.selectedImage.src = canvas.toDataURL('image/png', 1);
      this.app.selectedImage.wPos = h.wPos;
      this.app.selectedImage.hPos = h.hPos;
      this.app.selectedImage.xPos = h.xPos;
      this.app.selectedImage.yPos = h.yPos;
      this.setHolePositionToImage();
      this.app.selectedImage.groupSave.removeChildren();
      this.app.selectedImage.groupSave.add(this.app.selectedImage.imageSave);
      this.app.inCropMode = false;
      this.createHolesInBack();
      this.drawEditingCanvas();
    };
    imageObj.src = this.app.selectedImage.src;
  }

  acceptHeartCropImage() {
    console.log("Accept circle crop image");
    if (this.app.creating.cardHoles.length === 0) {
      console.log("No Card Holes");
      return;
    } //Card card hole to crop to
    let canvas: any = document.getElementById('imageCropper');
    if ((this.app.selectedImage === null || this.app.selectedImage === undefined) && this.app.creating.cardImage.length > 0) {
      this.app.selectedImage = this.app.creating.cardImage[0];
    }
    var h: CardHole = this.app.creating.cardHoles[0];

    canvas.width = h.wPos;
    canvas.height = h.hPos;
    // console.log("Canvas: ", canvas);
    let context: any = canvas.getContext('2d');
    context.width = h.wPos;
    context.height = h.hPos;
    // console.log("Context: ", context);
    let imageObj = new Image();

    imageObj.onload = () => {
      var wt = h.wPos;
      var ht = h.hPos;
      var xDif = h.xPos;
      var yDif = h.yPos;
      context.clearRect(0, 0, canvas.width, canvas.height);
      var tempH = new CardHole(-1, 0, 0, h.width, h.height, h.resizing, h.type, false);
      this.setHoleVals(tempH);
      this.cutter.clipHeart(tempH, context);
      context.clip();
      context.drawImage(imageObj, this.app.selectedImage.xPos - h.xPos, this.app.selectedImage.yPos - h.yPos,
        this.app.selectedImage.wPos, this.app.selectedImage.hPos);

      this.app.selectedImage.src = canvas.toDataURL('image/png', 1);
      this.app.selectedImage.wPos = h.wPos;
      this.app.selectedImage.hPos = h.hPos;
      this.app.selectedImage.xPos = h.xPos;
      this.app.selectedImage.yPos = h.yPos;
      this.setHolePositionToImage();
      this.app.selectedImage.groupSave.removeChildren();
      this.app.selectedImage.groupSave.add(this.app.selectedImage.imageSave);
      this.app.inCropMode = false;
      this.createHolesInBack();
      this.drawEditingCanvas();
    };
    imageObj.src = this.app.selectedImage.src;
  }

  acceptStarCropImage() {
    console.log("Accept circle crop image");
    if (this.app.creating.cardHoles.length === 0) {
      console.log("No Card Holes");
      return;
    } //Card card hole to crop to
    let canvas: any = document.getElementById('imageCropper');
    if ((this.app.selectedImage === null || this.app.selectedImage === undefined) && this.app.creating.cardImage.length > 0) {
      this.app.selectedImage = this.app.creating.cardImage[0];
    }
    var h: CardHole = this.app.creating.cardHoles[0];

    canvas.width = h.wPos;
    canvas.height = h.hPos;
    // console.log("Canvas: ", canvas);
    let context: any = canvas.getContext('2d');
    context.width = h.wPos;
    context.height = h.hPos;
    // console.log("Context: ", context);
    let imageObj = new Image();

    imageObj.onload = () => {
      var wt = h.wPos;
      var ht = h.hPos;
      var xDif = h.xPos;
      var yDif = h.yPos;
      context.clearRect(0, 0, canvas.width, canvas.height);
      var tempH = new CardHole(-1, 0, 0, h.width, h.height, h.resizing, h.type, false);
      this.setHoleVals(tempH);
      this.cutter.clipStar(tempH, context);
      context.clip();
      context.drawImage(imageObj, this.app.selectedImage.xPos - h.xPos, this.app.selectedImage.yPos - h.yPos,
        this.app.selectedImage.wPos, this.app.selectedImage.hPos);

      this.app.selectedImage.src = canvas.toDataURL('image/png', 1);
      this.app.selectedImage.wPos = h.wPos;
      this.app.selectedImage.hPos = h.hPos;
      this.app.selectedImage.xPos = h.xPos;
      this.app.selectedImage.yPos = h.yPos;
      this.setHolePositionToImage();
      this.app.selectedImage.groupSave.removeChildren();
      this.app.selectedImage.groupSave.add(this.app.selectedImage.imageSave);
      this.app.inCropMode = false;
      this.createHolesInBack();
      this.drawEditingCanvas();
    };
    imageObj.src = this.app.selectedImage.src;
  }

  setHolePositionToImage() {
    if (this.app.creating !== null && this.app.creating.cardHoles.length > 0) {
      var hole = this.app.creating.cardHoles[0];
      hole.wPos = this.app.selectedImage.wPos;
      hole.hPos = this.app.selectedImage.hPos;
      var x = (this.canvasWidth - hole.wPos) / 2;
      var y = (this.canvasHeight - hole.hPos) / 2;
      hole.xPos = x;
      hole.yPos = y;
      this.app.selectedImage.xPos = x;
      this.app.selectedImage.yPos = y;
    }
  }

  acceptCropImage() {
    let canvas: any = document.getElementById('imageCropper');
    let group = this.app.selectedImage.groupSave;
    let topLeft = group.get('.topLeft')[0];
    let bottomRight = group.get('.bottomRight')[0];

    canvas.width = this.app.selectedImage.width;
    canvas.height = this.app.selectedImage.height;
    // console.log("Canvas: ", canvas);
    let context: any = canvas.getContext('2d');
    context.width = this.app.selectedImage.width;
    context.height = this.app.selectedImage.height;
    // console.log("Context: ", context);
    let imageObj = new Image();

    imageObj.onload = () => {
      // console.log("In onload");
      // draw cropped image
      let sourceX = topLeft.getX() + 8;
      let sourceY = topLeft.getY() + 8;
      let sourceWidth = bottomRight.getX() - topLeft.getX();
      let sourceHeight = bottomRight.getY() - topLeft.getY();
      // console.log("Source X: ", sourceX, " Source Y: ", sourceY);
      // console.log("Source width: ", sourceWidth, " Source height: ", sourceHeight);
      let destWidth = this.app.selectedImage.width;
      let destHeight = this.app.selectedImage.height;
      // console.log("DestWidth: " + this.app.selectedImage.width + " DestHeight: " + this.app.selectedImage.height + "");
      let destX = 0;
      let destY = 0;
      // console.log("Width: " + imageObj.width + " Height: " + imageObj.height + "");

      let ratioX = imageObj.width / this.app.selectedImage.width;
      let ratioY = imageObj.height / this.app.selectedImage.height;
      let x = sourceX * ratioX;
      let y = sourceY * ratioY;
      let width = sourceWidth * ratioX;
      let height = sourceHeight * ratioY;

      context.drawImage(imageObj, x, y, width, height, destX, destY, destWidth, destHeight);
      this.app.selectedImage.src = canvas.toDataURL('image/png', 1);
      this.app.selectedImage.width = bottomRight.getX() - topLeft.getX();
      this.app.selectedImage.height = bottomRight.getY() - topLeft.getY();
      this.app.selectedImage.x = this.app.selectedImage.x + topLeft.getX() + 8;
      this.app.selectedImage.y = this.app.selectedImage.y + topLeft.getY() + 8;
      this.app.inCropMode = false;
      this.drawEditingCanvas();
    };
    // imageObj.height = this.app.selectedImage.height;
    // imageObj.width = this.app.selectedImage.width;
    imageObj.src = this.app.selectedImage.src;
  }

  cancelCropImage() {
    this.app.inCropMode = false;
    this.app.selectedImage.groupSave.removeChildren();
    this.app.selectedImage.groupSave.add(this.app.selectedImage.imageSave);
    this.drawEditingCanvas();
  }

  getFormatAnchor(itemWithResize: CardImage, type: number) {
    switch (type) {
      case 0:
        if (!itemWithResize.addedTLFAnchor) {
          itemWithResize.TLFAnchor = this.makeNewAnchor(itemWithResize, 'topLeft');
          itemWithResize.addedTLFAnchor = true;
        }
        return itemWithResize.TLFAnchor;
      case 1:
        if (!itemWithResize.addedTRFAnchor) {
          itemWithResize.TRFAnchor = this.makeNewAnchor(itemWithResize, 'topRight');
          itemWithResize.addedTRFAnchor = true;
        }
        return itemWithResize.TRFAnchor;
      case 2:
        if (!itemWithResize.addedBLFAnchor) {
          itemWithResize.addedBLFAnchor = true;
          itemWithResize.BLFAnchor = this.makeNewAnchor(itemWithResize, 'bottomLeft');
        }
        return itemWithResize.BLFAnchor;
      case 3:
        if (!itemWithResize.addedBRFAnchor) {
          itemWithResize.addedBRFAnchor = true;
          itemWithResize.BRFAnchor = this.makeNewAnchor(itemWithResize, 'bottomRight');
        }
        return itemWithResize.BRFAnchor;
    }
  }

  getCropAnchor(itemWithResize: CardImage, type: number) {
    switch (type) {
      case 0:
        if (!itemWithResize.addedTLCAnchor) {
          itemWithResize.TLCAnchor = this.makeCropAnchor('topLeftCrop', itemWithResize);
          itemWithResize.addedTLCAnchor = true;
        }
        return itemWithResize.TLCAnchor;
      case 1:
        if (!itemWithResize.addedTRCAnchor) {
          itemWithResize.TRCAnchor = this.makeCropAnchor('topRightCrop', itemWithResize);
          itemWithResize.addedTRCAnchor = true;
        }
        return itemWithResize.TRCAnchor;
      case 2:
        if (!itemWithResize.addedBLCAnchor) {
          itemWithResize.addedBLCAnchor = true;
          itemWithResize.BLCAnchor = this.makeCropAnchor('bottomLeftCrop', itemWithResize);
        }
        return itemWithResize.BLCAnchor;
      case 3:
        if (!itemWithResize.addedBRCAnchor) {
          itemWithResize.addedBRCAnchor = true;
          itemWithResize.BRCAnchor = this.makeCropAnchor('bottomRightCrop', itemWithResize);
        }
        return itemWithResize.BRCAnchor;
    }
  }

  finishAddAnchors(itemWithResize: CardImage, width, height, crop: boolean) {
    if (!crop) {
      console.log("Add anchors: ", width, height);
      this.addAnchor(this.getFormatAnchor(itemWithResize, 0), itemWithResize, itemWithResize.groupSave, 0, 0, 'topLeft');
      this.addAnchor(this.getFormatAnchor(itemWithResize, 1), itemWithResize, itemWithResize.groupSave, width, 0, 'topRight');
      this.addAnchor(this.getFormatAnchor(itemWithResize, 2), itemWithResize, itemWithResize.groupSave, 0, height, 'bottomLeft');
      this.addAnchor(this.getFormatAnchor(itemWithResize, 3), itemWithResize, itemWithResize.groupSave, width, height, 'bottomRight');
      console.log("At end of add anchors");
    } else {
      var half = this.cropCornersSize / 2;
      itemWithResize.groupSave.removeChildren();
      itemWithResize.groupSave.add(itemWithResize.imageSave);
      if (this.app.cropShape === 1) { //circle
        this.drawCropCircle(itemWithResize, itemWithResize.groupSave);
        this.addCropAnchor(this.getCropAnchor(itemWithResize, 0), itemWithResize, itemWithResize.groupSave,
          width / 2 - half, -1 * half, 'topLeftCrop');
        this.addCropAnchor(this.getCropAnchor(itemWithResize, 1), itemWithResize, itemWithResize.groupSave,
          width - half, height / 2 - half, 'topRightCrop');
        this.addCropAnchor(this.getCropAnchor(itemWithResize, 2), itemWithResize, itemWithResize.groupSave,
          -1 * half, height / 2 - half, 'bottomLeftCrop');
        this.addCropAnchor(this.getCropAnchor(itemWithResize, 3), itemWithResize, itemWithResize.groupSave,
          width / 2 - half, height - half, 'bottomRightCrop');
      } else if (this.app.cropShape === 0) { //square
        this.addCropAnchor(this.getCropAnchor(itemWithResize, 0), itemWithResize, itemWithResize.groupSave,
          -1 * half, -1 * half, 'topLeftCrop');
        this.addCropAnchor(this.getCropAnchor(itemWithResize, 1), itemWithResize, itemWithResize.groupSave,
          width - half, -1 * half, 'topRightCrop');
        this.addCropAnchor(this.getCropAnchor(itemWithResize, 2), itemWithResize, itemWithResize.groupSave,
          -1 * half, height - half, 'bottomLeftCrop');
        this.addCropAnchor(this.getCropAnchor(itemWithResize, 3), itemWithResize, itemWithResize.groupSave,
          width - half, height - half, 'bottomRightCrop');
        this.drawCropLines(itemWithResize);
      }
    }
    if (this.drawCanvasDefer) {
      this.drawCanvasDefer();
      this.drawCanvasDefer = null;
    }
  }

  makeNewAnchor(itemWithResize: CardImage, name: string) {
    let anchor = new Konva.Circle({
      x: 0,
      y: 0,
      stroke: '#000000',
      fill: '#ffffff',
      strokeWidth: 2,
      radius: itemWithResize.type === ImageType.text ? 16 : 0,
      name: name,
      draggable: true,
      dragOnTop: false
    });

    anchor.on('dragmove', () => {
      // console.log("Anchor drag move");
      if (this.app.selectedImage.type === "text") {
        this.app.selectedImage.textResized = true;
      }
      this.dragMove(anchor, this.layer, itemWithResize);
      this.clearUpdating();
    });
    anchor.on('mousedown touchstart', () => {
      this.mouseDown(anchor, this.app.selectedImage.groupSave);
    });
    anchor.on('dragend', () => {
      if (this.app.selectedImage.imageSave.attrs.height < 0 || this.app.selectedImage.imageSave.attrs.width < 0) {
        // console.log("Image.width is negative, returning now");
        return;
      }
      this.app.selectedImage.wPos = this.app.selectedImage.imageSave.attrs.width;
      this.app.selectedImage.hPos = this.app.selectedImage.imageSave.attrs.height;
      let newX = this.app.selectedImage.groupSave.attrs.x + this.app.selectedImage.imageSave.attrs.x;
      let newY = this.app.selectedImage.groupSave.attrs.y + this.app.selectedImage.imageSave.attrs.y;
      this.app.selectedImage.xPos = newX;
      this.app.selectedImage.yPos = newY;
      // console.log("Selected image: ", this.app.selectedImage);
      this.app.selectedImage.groupSave.setDraggable(true);
      this.layer.draw();
      if (this.app.selectedImage.type === "text" && this.app.selectedImage.textResized === true) {
        // console.log("Is text image and was resized");
        this.app.selectedImage.textResized = false;
        this.refreshTextItemSize();
        return;
      }
      this.setUpdatePreview();
    });
    // add hover styling
    anchor.on('mouseover', () => {
      document.body.style.cursor = 'pointer';
      anchor.setStrokeWidth(4);
      this.layer.draw();
    });
    anchor.on('mouseout', () => {
      document.body.style.cursor = 'default';
      anchor.setStrokeWidth(2);
      this.layer.draw();
    });

    return anchor;
  }

  addAnchor(anchor, item: CardImage, group, x, y, name) {
    let layer = group.getLayer();

    anchor.setAttrs({
      x: x,
      y: y,
      stroke: '#000000',
      fill: '#ffffff',
      strokeWidth: 2,
      radius: item.type === ImageType.text ? 16 : 0,
      name: name,
      draggable: true,
      dragOnTop: false
    });
    anchor.draggable(true);

    group.add(anchor);
    item.hasFormatAnchorsAdded = true;
  }

  setupNewImage(id, type, src, draggable, resizable, width, height, x, y, uploaded, textSetup = null) {
    this.app.creating.cardImage.push(this.makeImageObject(id, type, src, draggable, resizable, width, height, x, y, uploaded, textSetup));
  }

  setupNewTextImage(id, type, src, draggable, resizable, width, height, x, y, uploaded, textSetup = null) {
    this.app.creating.cardText.push(this.makeImageObject(id, type, src, draggable, resizable, width, height, x, y, uploaded, textSetup));
  }

  makeImageObject(id: number, type: ImageType, src: string, draggable: boolean, resizable: boolean, width: number,
                  height: number, x: number, y: number, uploaded: boolean, textSetup: CardText): CardImage {
    return new CardImage(id, type, src, draggable, resizable, width, height, x, y, uploaded, textSetup);
  }

  createNewImage(info: CardImage, src, draggable, resizable, width, height, x, y, layer) {
    console.log("Create new image: ", info);
    let data = new Image();
    if (info.hasKonvaImage) {
      info.imageSave.setAttrs({
        x: 0,
        y: 0,
        width: width,
        height: height
      });
    } else {
      let image = new Konva.Image({
        x: 0,
        y: 0,
        width: width,
        height: height
      });
      info.imageSave = image;
      info.hasKonvaImage = true;
    }

    if (info.hasKonvaGroup) {
      info.groupSave.setAttrs({
        x: x,
        y: y,
        draggable: draggable
      });
    } else {
      let group = new Konva.Group({
        x: x,
        y: y,
        draggable: draggable
      });
      info.groupSave = group;
      info.hasKonvaGroup = true;
    }

    if (resizable) {
      this.groupSave = info.groupSave;
    }
    layer.add(info.groupSave);
    info.groupSave.add(info.imageSave);
    info.groupSave.off("touchend");
    info.groupSave.off("dragmove");
    info.groupSave.off("dragend");
    info.groupSave.on("touchend", (e) => {
      console.log("Group touch: ", e);
      this.imageTap(e, info);
    });
    info.groupSave.on("dragmove", (e) => {
      if (e.evt.touches.length > 1) {
        this.handleMultiTouch(e, false);
      } else {
        let x = 0, y = 0;
        if (this.app.selectedImage.imageSave.attrs.x != null)
          x = this.app.selectedImage.imageSave.attrs.x;
        if (this.app.selectedImage.imageSave.attrs.y != null)
          y = this.app.selectedImage.imageSave.attrs.y;
        this.app.selectedImage.xPos = this.app.selectedImage.groupSave.attrs.x + x;
        this.app.selectedImage.yPos = this.app.selectedImage.groupSave.attrs.y + y;
        this.clearUpdating();
      }
    });
    info.groupSave.on("dragend", (e) => {
      console.log("Drag end");
      if (this.app.selectedImage.multiTouch) {
        console.log("Multi touch drag end");
        this.handleMultiTouch(e, true);
      }
        let x = 0, y = 0;
        if (this.app.selectedImage.imageSave.attrs.x != null)
          x = this.app.selectedImage.imageSave.attrs.x;
        if (this.app.selectedImage.imageSave.attrs.y != null)
          y = this.app.selectedImage.imageSave.attrs.y;
        this.app.selectedImage.xPos = this.app.selectedImage.groupSave.attrs.x + x;
        this.app.selectedImage.yPos = this.app.selectedImage.groupSave.attrs.y + y;
        console.log("Sel image: ", this.app.selectedImage);
        if (this.app.inCropMode) return;
        this.clearUpdating();
        this.makeSnapshot();
    });

    data.onload = () => {
      info.imageSave.image(data);
      console.log("Image on load");
      this.layer.draw();
    };
    data.src = src;
  }

  handleMultiTouch(e, end: boolean) {
    if (!this.app.selectedImage.multiTouch) {
      console.log("Multi touch start");
      this.app.selectedImage.touchAtStart = e.evt.touches;
      this.app.selectedImage.multiTouch = true;
    } else {
      if (end) {
        this.app.selectedImage.multiTouch = false;
        this.app.selectedImage.xPos = this.app.selectedImage.tempX;
        this.app.selectedImage.yPos = this.app.selectedImage.tempY;
        this.app.selectedImage.wPos = this.app.selectedImage.tempW;
        this.app.selectedImage.hPos = this.app.selectedImage.tempH;
        this.clearUpdating();
        this.makeSnapshot();
      } else {
        this.applyPinchZoom(this.app.selectedImage.touchAtStart, e.evt.touches);
      }
    }
  }

  applyPinchZoom(start, now) {
    var s1 = start[0];
    var s2 = start[1];
    var e1 = now[0];
    var e2 = now[1];
    var d1 = Math.abs(s1.screenY - s2.screenY);
    var d2 = Math.abs(e1.screenY - e2.screenY);
    var heightChange = d2 - d1;
    console.log("Height Change: ", heightChange);
    var widthChange = (heightChange / this.app.selectedImage.hPos) * this.app.selectedImage.wPos;

    this.app.selectedImage.tempH = Math.abs(this.app.selectedImage.hPos + heightChange);
    this.app.selectedImage.tempW = Math.abs(this.app.selectedImage.wPos + widthChange);
    this.app.selectedImage.tempX = this.app.selectedImage.xPos - (widthChange / 2);
    this.app.selectedImage.tempY = this.app.selectedImage.yPos - (heightChange / 2);
    this.updateAnchorsOnPinch(heightChange, widthChange);
    this.layer.draw();
  }

  updateAnchorsOnPinch(hc: number, wc: number) {
    this.app.selectedImage.imageSave.width(this.app.selectedImage.tempW);
    this.app.selectedImage.imageSave.height(this.app.selectedImage.tempH);
    console.log("TempX: ", this.app.selectedImage.tempX);
    console.log("TempY: ", this.app.selectedImage.tempY);
    this.app.selectedImage.groupSave.setAttrs({
      x: this.app.selectedImage.tempX,
      y: this.app.selectedImage.tempY,
      width: this.app.selectedImage.tempW,
      height: this.app.selectedImage.tempH
    });
    var x = this.app.selectedImage.tempX;
    var y = this.app.selectedImage.tempY;
    var h = this.app.selectedImage.tempH;
    var w = this.app.selectedImage.tempW;
    let topLeft = this.app.selectedImage.TLFAnchor;
    let topRight = this.app.selectedImage.TRFAnchor;
    let bottomRight = this.app.selectedImage.BRFAnchor;
    let bottomLeft = this.app.selectedImage.BLFAnchor;
    // topLeft.setX(x);
    // topLeft.setY(y);
    topRight.setX(this.app.selectedImage.tempW);
    bottomLeft.setY(this.app.selectedImage.tempH);
    bottomRight.setX(this.app.selectedImage.tempW);
    bottomRight.setY(this.app.selectedImage.tempH);
  }

  drawCardBack = (info: CardBack) => {
    let data = new Image();
    if (info.hasKonvaImage) {
      info.imageSave.setAttrs({
        x: 0,
        y: 0,
        width: this.canvasWidth,
        height: this.canvasHeight
      });
    } else {
      let image = new Konva.Image({
        x: 0,
        y: 0,
        width: this.canvasWidth,
        height: this.canvasHeight
      });
      info.imageSave = image;
      info.hasKonvaImage = true;
    }

    if (info.hasKonvaGroup) {
      info.groupSave.setAttrs({
        x: 0,
        y: 0,
        draggable: false
      });
    } else {
      let group = new Konva.Group({
        x: 0,
        y: 0,
        draggable: false
      });
      info.groupSave = group;
      info.hasKonvaGroup = true;
    }
    this.layer.add(info.groupSave);
    info.groupSave.add(info.imageSave);

    data.onload = () => {
      info.imageSave.image(data);
      this.layer.draw();
    };
    data.src = info.holedBack;
  }


  makeCropAnchor(name: string, itemWithResize: CardImage) {
    let anchor = new Konva.Rect({
      x: 0,
      y: 0,
      stroke: '#ffffff',
      width: 16,
      height: 16,
      fill: "red",
      name: name,
      strokeWidth: 0,
      draggable: true,
      dragOnTop: false
    });

    anchor.on('dragmove', () => {
      // console.log("Crop Drag move");
      this.app.selectedImage.groupSave.setDraggable(false);
      this.dragMove(anchor, this.layer, itemWithResize, true, null);
      this.clearUpdating();
    });
    anchor.on('mousedown touchstart', () => {
      // console.log("Crop Mouse down");
      this.mouseDown(anchor, this.app.selectedImage.groupSave);
    });
    anchor.on('dragend', () => {
      console.log("Crop Drag end");
      this.app.selectedImage.groupSave.setDraggable(true);
      this.layer.draw();
    });
    // add hover styling
    anchor.on('mouseover', function() {
      // console.log("Crop Mouse over");
      document.body.style.cursor = 'pointer';
      this.setStrokeWidth(4);
      this.layer.draw();
    });
    anchor.on('mouseout', function() {
      // console.log("Crop Mouse out");
      document.body.style.cursor = 'default';
      this.setStrokeWidth(2);
      this.layer.draw();
    });

    return anchor;
  }

  addCropAnchor(anchor, image: CardImage, group, x, y, name) {
    anchor.setAttrs({
      x: x,
      y: y,
      stroke: '#ffffff',
      width: this.cropCornersSize,
      height: this.cropCornersSize,
      fill: "red",
      name: name,
      strokeWidth: 0,
      draggable: true,
      dragOnTop: false
    });

    group.add(anchor);
    image.hasCropAnchorsAdded = true;
  }

  drawCropCircle(item: CardImage, group) {
    // console.log("Draw crop circle: ", item, group);
    let anchor = new Konva.Ellipse({
      x: (item.wPos / 2),
      y: (item.hPos / 2),
      stroke: 'red',
      fill: '#ffffff00',
      strokeWidth: 4,
      radius: {x: (item.wPos / 2), y: (item.hPos / 2)},
      name: 'cropCircle',
      draggable: false,
      dragOnTop: false
    });

    group.add(anchor);
  }

  drawCropLines(item: CardImage) {
    var group = item.groupSave;
    let topLeft = item.TLCAnchor;
    let topRight = item.TRCAnchor;
    let bottomRight = item.BRCAnchor;
    let bottomLeft = item.BLCAnchor;

    // console.log("Top Left = X: " + topLeft.getX() + " Y: " + topLeft.getY());

    let tlX = topLeft.getX() + (this.cropCornersSize / 2);
    let tlY = topLeft.getY() + (this.cropCornersSize / 2);
    let trX = topRight.getX()  + (this.cropCornersSize / 2);
    let trY = topRight.getY()  + (this.cropCornersSize / 2);

    let brX = bottomRight.getX() + (this.cropCornersSize / 2);
    let brY = bottomRight.getY() + (this.cropCornersSize / 2);
    let blX = bottomLeft.getX() + (this.cropCornersSize / 2);
    let blY = bottomLeft.getY() + (this.cropCornersSize / 2);

    this.addCropLine(group, tlX  + (this.cropCornersSize / 2), tlY, trX  - tlX - (this.cropCornersSize), true, "topLine", "red");
    this.addCropLine(group, trX, trY  + (this.cropCornersSize / 2), brY  - trY - (this.cropCornersSize), false, "rightLine", "red");
    this.addCropLine(group, tlX, tlY  + (this.cropCornersSize / 2), blY  - tlY - (this.cropCornersSize), false, "leftLine", "red");
    this.addCropLine(group, blX  + (this.cropCornersSize / 2), blY, brX  - blX - (this.cropCornersSize), true, "bottomLine", "red");
  }

  addCropLine(group, x, y, length, toSide, name, color) {
    let anchor = new Konva.Rect({
      x: x,
      y: y,
      stroke: color,
      width: toSide ? length : 2,
      height: toSide ? 2: length,
      fill: color,
      name: name,
      strokeWidth: 1
    });

    group.add(anchor);
  }

  addNewTextImage = () => {
    if (this.countTextObjects() >= 4) {
      this.app.errorText = "You have reached the maximum number of text boxes already. Please consider combining some to add more text.";
      $('#errorModal').modal('show');
      return;
    }
    this.removeAllFormattingAnchors();
    var textImage = null;
    if (this.app.creating.cardText.length > 0) {
      var prev: CardImage = (this.app.selectedImage !== null && this.app.selectedImage.type === ImageType.text)
        ? this.app.selectedImage : this.app.creating.cardText[this.app.creating.cardText.length - 1];
      textImage = this.makeImageObject(this.app.creating.cardText.length > 0 ?
        this.app.creating.cardText[this.app.creating.cardText.length - 1].id + 1 : 1, ImageType.text, '',
        false, true, 200, 200, 25, 25, false,
        new CardText("(Type Here)", prev.textSetup.fontSize, prev.textSetup.font, prev.textSetup.color,
          TextShape.NONE, '#FFFFFF',
          '#FFFFFF', 0, 0, 0));
    } else {
      textImage = this.makeImageObject(this.app.creating.cardText.length > 0 ?
        this.app.creating.cardText[this.app.creating.cardText.length - 1].id + 1 : 1, ImageType.text, '',
        false, true, 200, 200, 25, 25, false,
        new CardText("(Type Here)", 30, "Arial", "#FFFFFF", TextShape.NONE, '#FFFFFF',
          '#FFFFFF', 0, 0, 0));
    }

    this.setImageVals(textImage);
    this.app.creating.cardText.forEach((t) => {
      t.resizable = false;
    });
    this.app.creating.cardText.push(textImage);
    this.app.selectedImage = textImage;
    this.drawEditingCanvas();
  }

  removeAllFormattingAnchors() {
    this.app.creating.cardText.forEach((t) => {
      t.resizable = false;
    });
    this.app.creating.cardImage.forEach((i) => {
      i.resizable = false;
    });
    this.app.creating.cardHoles.forEach((h) => {
      h.resizing = false;
    });
  }

  countTextObjects() {
    return this.app.creating.cardText.length;
  }

  createTextImage(imageInfo: CardImage, layer: any) {
    console.log("Starting make text image");
    let textWidth = this.getTextWidth(imageInfo);
    let canvas2 = document.createElement("canvas");
    canvas2.style.display = "none";
    document.body.appendChild(canvas2);
    let ctx2 = canvas2.getContext("2d");
    var adjust = Math.ceil(textWidth * 0.1);
    var height = imageInfo.textSetup.fontSize * 1.75;
    imageInfo.wPos = Math.ceil(textWidth + (adjust * 2) + imageInfo.textSetup.extraWidth + (imageInfo.textSetup.borderWidth * 2));
    imageInfo.hPos = Math.ceil(height + imageInfo.textSetup.extraHeight + (imageInfo.textSetup.borderWidth * 2));
    canvas2.width = Math.ceil(textWidth + (adjust * 2));
    canvas2.height = Math.ceil(imageInfo.textSetup.fontSize * 1.75);
    ctx2.font = imageInfo.textSetup.fontSize + "px " + imageInfo.textSetup.font;
    ctx2.textAlign = "left";
    ctx2.fillStyle = imageInfo.textSetup.color;
    ctx2.strokeStyle = 'black';
    ctx2.lineWidth = 2;
    ctx2.strokeText(imageInfo.textSetup.text, adjust, imageInfo.textSetup.fontSize + 5);
    ctx2.fillText(imageInfo.textSetup.text, adjust, imageInfo.textSetup.fontSize + 5);

    let image = new Image();
    image.crossOrigin = "Anonymous";
    image.onload = () => {

    };
    image.src = canvas2.toDataURL("image/png", 1);
    imageInfo.src = image.src;
    this.textImageLoaded(image, imageInfo, layer);
    document.body.removeChild(canvas2);
    console.log("Made text image");
  }

  drawBackground(text: CardImage, canvas: any, ctx: any, width: number, height: number) {
    ctx.fillStyle = text.textSetup.shapeColor;
    if (text.textSetup.shape === TextShape.SQUARE) {
      ctx.fillRect(0, 0, width, height);
    } else {
      ctx.beginPath();
      ctx.ellipse(width / 2, height / 2, width / 2, height / 2, Math.PI, 0, 2 * Math.PI);
      ctx.closePath();
      ctx.fill();
    }
  }

  drawTextBorder(text: CardImage, canvas: any, ctx: any, width: number, height: number) {
    ctx.strokeStyle = text.textSetup.borderColor;
    ctx.lineWidth = text.textSetup.borderWidth;
    if (text.textSetup.shape === TextShape.SQUARE) {
      ctx.strokeRect(text.textSetup.borderWidth / 2, text.textSetup.borderWidth / 2,
        width - text.textSetup.borderWidth, height - text.textSetup.borderWidth);
    } else {
      ctx.beginPath();
      ctx.ellipse(width / 2, height / 2, (width / 2) - (text.textSetup.borderWidth / 2),
        (height / 2) - (text.textSetup.borderWidth / 2), Math.PI, 0, 2 * Math.PI);
      ctx.closePath();
      ctx.stroke();
    }
  }

  getTextWidth(imageInfo) {
    let canvas = document.createElement("canvas");
    canvas.style.display = "none";
    document.body.appendChild(canvas);

    canvas.width = 600;
    canvas.height = 400;
    let ctx = canvas.getContext("2d");
    ctx.font = imageInfo.textSetup.fontSize + "px " + imageInfo.textSetup.font;
    ctx.textAlign = "left";
    ctx.fillStyle = imageInfo.textSetup.color;
    ctx.lineWidth = 2;
    let textWidth = ctx.measureText(imageInfo.textSetup.text).width;
    document.body.removeChild(canvas);
    return textWidth;
  }

  makeSnapshot = () => {
    if (this.app.viewMode === 0) return;
    let canvas: any = document.getElementById("cardBackMaker");
    canvas.width = this.canvasWidth;
    canvas.height = this.canvasHeight;
    let context: any = canvas.getContext('2d');
    context.width = this.canvasWidth;
    context.height = this.canvasHeight;
    let wh = this.getCanvasWidthAndHeight();
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = this.app.backgroundColor;
    context.fillRect(0, 0, wh.w, wh.h);
    this.addCardElements(0, 0, canvas, context);
  }

  addCardElements(part: number, index: number, canvas, context) {
    switch(part) {
      case 0:
        if (this.app.creating.cardImage.length > index) {
          this.snapshotAddImage(this.app.creating.cardImage[index], part, index, canvas, context);
        } else {
          this.addCardElements(1, 0, canvas, context);
        }
        break;
      case 1:
        this.addHoledCardBack(canvas, context);
        break;
      case 2:
        if (this.app.creating.cardText.length > index) {
          console.log("Adding text image");
          this.snapshotAddImage(this.app.creating.cardText[index], part, index, canvas, context);
        } else {
          console.log("here");
          this.addCardElements(3, 0, canvas, context);
        }
        break;
      case 3:
        console.log("Finish snapshot");
        this.finishSnapshot(canvas, context);
        break;
    }
  }

  finishSnapshot(canvas, context) {
    console.log("Finishing snapshot");
    this.generatedCardBack = canvas.toDataURL("image/png", 1);
    // setTimeout(() => {
    //   $('#canvasContainer').click();
    // });
  }

  snapshotAddImage(i: CardImage, part: number, index: number, canvas, context) {
    // console.log("Snapshot add image: ", i, "Src", i.src);
    var image = new Image();
    image.onload = () => {
      image.height = i.hPos;
      image.width = i.wPos;
      context.drawImage(image, i.xPos, i.yPos, i.wPos, i.hPos);
      console.log("After draw image");
      this.addCardElements(part, index + 1, canvas, context);
    };
    image.src = i.src;
  }

  addHoledCardBack(canvas, context) {
    var image = new Image();
    image.onload = () => {
      context.drawImage(image, 0, 0);
      this.addCardElements(2, 0, canvas, context);
    };
    image.src = this.app.creating.cardBack.holedBack;
  }

  update(activeAnchor, crop, itemWithResize: CardImage) {
    console.log("Update anchor");
    let group = activeAnchor.getParent();
    let topLeft = crop ? this.app.selectedImage.TLCAnchor : this.app.selectedImage.TLFAnchor;
    let topRight = crop ? this.app.selectedImage.TRCAnchor : this.app.selectedImage.TRFAnchor;
    let bottomRight = crop ? this.app.selectedImage.BRCAnchor : this.app.selectedImage.BRFAnchor;
    let bottomLeft = crop ? this.app.selectedImage.BLCAnchor : this.app.selectedImage.BLFAnchor;
    let image = this.app.selectedImage.imageSave;

    console.log("TLF: ", this.app.selectedImage.TLFAnchor, image);

    if(crop) {
      this.updateCropAnchors(activeAnchor, group);
    } else {
      this.updateFormatAnchors(activeAnchor, group);
    }

    if (!crop) {
      image.position(topLeft.position());

      let width = topRight.getX() - topLeft.getX();
      let height = bottomLeft.getY() - topLeft.getY();
      if(width && height) {
        image.width(width);
        image.height(height);
      }
    } else { //Specific stuff for when cropping
      // console.log("Cropping drag: Width = " + this.app.selectedImage.width + " Height = " + this.app.selectedImage.height);
      if (this.app.cropShape === 0) {
        this.updateCropLines(activeAnchor, group, itemWithResize);
      } else if (this.app.cropShape === 1) {
        this.updateCropCircle();
      }
    }
  }

  updateFormatAnchors(activeAnchor, group) {
    let topLeft = this.app.selectedImage.TLFAnchor;
    let topRight = this.app.selectedImage.TRFAnchor;
    let bottomRight = this.app.selectedImage.BRFAnchor;
    let bottomLeft = this.app.selectedImage.BLFAnchor;
    let image = this.app.selectedImage.imageSave;

    let anchorX = activeAnchor.getX();
    let anchorY = activeAnchor.getY();

    var currX = this.app.selectedImage.xPos;
    var currY = this.app.selectedImage.yPos;
    var w = this.app.selectedImage.wPos;
    var h = this.app.selectedImage.hPos;
    var ar = this.app.selectedImage.aspectRatio;

    var opx1 = this.app.selectedImage.type === ImageType.image ? anchorX : anchorX;
    var opy1 = this.app.selectedImage.type === ImageType.image ? (anchorX * ar) : anchorY;
    var opx2 = this.app.selectedImage.type === ImageType.image ? (anchorY / ar) : anchorX;
    var opy2 = this.app.selectedImage.type === ImageType.image ? anchorY : anchorY;

    console.log("AnchorX: ", anchorX);
    console.log("AnchorY: ", anchorY);

    // update anchor positions
    switch (activeAnchor.getName()) {
      case 'topLeft':
        topLeft.setY(opy1);
        topLeft.setX(opx1);
        topRight.setY(opy1);
        bottomLeft.setX(opx1);
        break;
      case 'topRight':
        if (this.app.selectedImage.type === ImageType.image) {
          opx2 = w - opx2;
        }
        topRight.setX(opx2);
        topRight.setY(opy2);
        topLeft.setY(opy2);
        bottomRight.setX(opx2);
        break;
      case 'bottomRight':
        bottomRight.setX(opx1);
        bottomRight.setY(opy1);
        bottomLeft.setY(opy1);
        topRight.setX(opx1);
        break;
      case 'bottomLeft':
        if (this.app.selectedImage.type === ImageType.image) {
          opx2 = w - opx2;
        }
        bottomLeft.setX(opx2);
        bottomLeft.setY(opy2);
        bottomRight.setY(opy2);
        topLeft.setX(opx2);
        break;
    }
  }

  updateCropAnchors(activeAnchor, group) {
    let topLeft = group.get('.topLeftCrop')[0];
    let topRight = group.get('.topRightCrop')[0];
    let bottomRight = group.get('.bottomRightCrop')[0];
    let bottomLeft = group.get('.bottomLeftCrop')[0];
    let image = group.get('Image')[0];

    let anchorX = activeAnchor.getX();
    let anchorY = activeAnchor.getY();

    // update anchor positions
    if (this.app.cropShape === 0) { //square
      switch (activeAnchor.getName()) {
        case 'topLeftCrop':
          topRight.setY(anchorY);
          bottomLeft.setX(anchorX);
          break;
        case 'topRightCrop':
          topLeft.setY(anchorY);
          bottomRight.setX(anchorX);
          break;
        case 'bottomRightCrop':
          bottomLeft.setY(anchorY);
          topRight.setX(anchorX);
          break;
        case 'bottomLeftCrop':
          bottomRight.setY(anchorY);
          topLeft.setX(anchorX);
          break;
      }
    } else {
      var x = 0;
      var y = 0;
      switch (activeAnchor.getName()) {
        case 'topLeftCrop':
          y = ((bottomRight.getY() - topLeft.getY()) / 2) + (topLeft.getY());
          topLeft.setX(bottomRight.getX());
          topRight.setY(y);
          bottomLeft.setY(y);
          break;
        case 'topRightCrop':
          x = ((topRight.getX() - bottomLeft.getX()) / 2) + (bottomLeft.getX());
          topRight.setY(bottomLeft.getY());
          topLeft.setX(x);
          bottomRight.setX(x);
          break;
        case 'bottomRightCrop':
          y = ((bottomRight.getY() - topLeft.getY()) / 2) + (topLeft.getY());
          bottomRight.setX(topLeft.getX());
          topRight.setY(y);
          bottomLeft.setY(y);
          break;
        case 'bottomLeftCrop':
          x = ((topRight.getX() - bottomLeft.getX()) / 2) + (bottomLeft.getX());
          bottomLeft.setY(topRight.getY());
          topLeft.setX(x);
          bottomRight.setX(x);
          break;
      }
    }
  }

  updateCropCircle() {
    let circle = this.app.selectedImage.groupSave.get('.cropCircle')[0];
    // console.log("Crop circle: ", circle);

    let topLeft = this.app.selectedImage.TLCAnchor;
    let topRight = this.app.selectedImage.TRCAnchor;
    let bottomRight = this.app.selectedImage.BRCAnchor;
    let bottomLeft = this.app.selectedImage.BLCAnchor;

    let x = topLeft.getX() + (this.cropCornersSize / 2);
    let y = topRight.getY() + (this.cropCornersSize / 2);
    let xr = ((topRight.getX() - bottomLeft.getX()) / 2);
    let yr = ((bottomRight.getY() - topLeft.getY()) / 2);
    circle.setAttrs({
      x: x,
      y: y,
      radius: {x: xr, y: yr}
    });
  }

  updateCropLines(activeAnchor, group, itemWithResize: CardImage) {
    let top = group.get('.topLine')[0];
    let right = group.get('.rightLine')[0];
    let left = group.get('.leftLine')[0];
    let bottom = group.get('.bottomLine')[0];

    let topLeft = this.app.selectedImage.TLCAnchor;
    let topRight = this.app.selectedImage.TRCAnchor;
    let bottomRight = this.app.selectedImage.BRCAnchor;
    let bottomLeft = this.app.selectedImage.BLCAnchor;
    let image = this.app.selectedImage.imageSave;

    let anchorX = activeAnchor.getX();
    let anchorY = activeAnchor.getY();
    let half = (this.cropCornersSize / 2);

    switch (activeAnchor.getName()) {
      case 'topLeftCrop':
        top.setY(anchorY + half);
        top.setX(anchorX + this.cropCornersSize);
        top.setWidth(topRight.getX() - anchorX - this.cropCornersSize);
        bottom.setY(bottomLeft.getY() + half);
        bottom.setX(bottomLeft.getX() + this.cropCornersSize);
        bottom.setWidth(topRight.getX() - anchorX - this.cropCornersSize);
        left.setX(anchorX + half);
        left.setY(anchorY + this.cropCornersSize);
        left.setHeight(bottomLeft.getY() - anchorY - this.cropCornersSize);
        right.setX(topRight.getX() + half);
        right.setY(topRight.getY() + this.cropCornersSize);
        right.setHeight(bottomLeft.getY() - anchorY - this.cropCornersSize);
        break;
      case 'topRightCrop':
        top.setY(topLeft.getY() + half);
        top.setX(topLeft.getX() + this.cropCornersSize);
        top.setWidth(anchorX - topLeft.getX() - this.cropCornersSize);
        bottom.setWidth(anchorX - topLeft.getX() - this.cropCornersSize);
        right.setX(anchorX + half);
        right.setY(anchorY + this.cropCornersSize);
        right.setHeight(bottomRight.getY() - anchorY - this.cropCornersSize);
        left.setY(topLeft.getY() + this.cropCornersSize);
        left.setX(topLeft.getX() + half);
        left.setHeight(bottomRight.getY() - anchorY - this.cropCornersSize);
        break;
      case 'bottomRightCrop':
        bottom.setY(bottomLeft.getY() + half);
        bottom.setX(bottomLeft.getX() + this.cropCornersSize);
        bottom.setWidth(anchorX - bottomLeft.getX() - this.cropCornersSize);
        top.setWidth(anchorX - bottomLeft.getX() - this.cropCornersSize);
        right.setX(topRight.getX() + half);
        right.setY(topRight.getY() + this.cropCornersSize);
        right.setHeight(anchorY - topRight.getY() - this.cropCornersSize);
        left.setHeight(anchorY - topRight.getY() - this.cropCornersSize);
        break;
      case 'bottomLeftCrop':
        bottom.setY(anchorY + half);
        bottom.setX(anchorX + this.cropCornersSize);
        bottom.setWidth(bottomRight.getX() - anchorX - this.cropCornersSize);
        top.setX(topLeft.getX() + this.cropCornersSize);
        top.setY(topLeft.getY() + half);
        top.setWidth(bottomRight.getX() - anchorX - this.cropCornersSize);
        left.setX(topLeft.getX() + half);
        left.setY(topLeft.getY() + this.cropCornersSize);
        left.setHeight(anchorY - topLeft.getY() - this.cropCornersSize);
        right.setHeight(anchorY - topLeft.getY() - this.cropCornersSize);
        break;
    }
  }

  refreshTextItemSize() {
    let newWidth = this.app.selectedImage.wPos;
    let origFont = this.app.selectedImage.textSetup.fontSize;
    let newFont = origFont;
    // console.log("Item font size: ", );
    // console.log("New width that's needed: ", );
    let origWidth = this.getTextWidth(this.app.selectedImage);
    // console.log("Orig width: ", origWidth);
    if (origWidth < newWidth) {
      while (origWidth < newWidth) {
        origFont = origFont + 1;
        this.app.selectedImage.textSetup.fontSize = origFont;
        origWidth = this.getTextWidth(this.app.selectedImage);
      }
      origFont = origFont - 1;
    } else {
      while (origWidth > newWidth) {
        origFont = origFont - 1;
        this.app.selectedImage.textSetup.fontSize = origFont;
        origWidth = this.getTextWidth(this.app.selectedImage);
      }
      origFont = origFont + 1;
    }
    this.app.selectedImage.textSetup.fontSize = origFont;
    // console.log("New font size: ", origFont);
    this.drawEditingCanvas();
  }

  /*
    ************************************************
    ************************************************
    ************************************************
    ************************************************
    ************************************************
    ************************************************
     OLD CODE GOES BELOW HERE, ONLY CREATE NEW CODE
    ************************************************
    ************************************************
    ************************************************
    ************************************************
    ************************************************
   */
  getSnapshot(addBack = true, images = null, addAnchors = true) {
    let stage = new Konva.Stage({
      container: 'previewGenerator',
      width: this.canvasWidth,
      height: this.canvasHeight

    });
    let layer = new Konva.Layer();
    if (addBack) {
      let wh = this.getCanvasWidthAndHeight();
      let rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: wh.w,
        height: wh.h,
        fill: this.app.backgroundColor,
        stroke: this.app.backgroundColor,
        strokeWidth: 0
      });
      layer.add(rect);
    }
    stage.add(layer);
    this.runPreviewMaker(stage, layer, images, addAnchors);
  }

  drawPreviewCanvas(generatingCard = false) {
    // console.log("Drawing preview canvas");
    // console.log("Generating card? ", generatingCard);
    return;
    // this.stage = new Konva.Stage({
    //   container: 'container',
    //   width: this.canvasWidth,
    //   height: this.canvasHeight
    //
    // });
    // this.layer = new Konva.Layer();
    // this.stage.add(this.layer);
    // if (generatingCard) {
    //   let wh = this.getCanvasWidthAndHeight();
    //   let rect = new Konva.Rect({
    //     x: 0,
    //     y: 0,
    //     width: wh.w,
    //     height: wh.h,
    //     fill: this.app.backgroundColor,
    //     stroke: this.app.backgroundColor,
    //     strokeWidth: 0
    //   });
    //   this.layer.add(rect);
    // }
    // this.runPreviewMaker(this.stage, this.layer);
  }

  readyClicked() {
    if (this.app.selectedSavedCard !== null) {
      $('#cardSaveTypeModal').modal('show');
    } else {
      this.createNewCardToSave();
    }
  }

  editClicked() {
    this.app.showReady = false;
    this.app.viewMode = 0;
  }

  trashClicked() {
    this.app.showReady = false;
    this.app.showAllButtons = true;
    this.app.viewMode = 0;
    this.app.selectedCardBack = this.cardBackList[0];
    this.app.selectedImage = null;
    var hole = new CardHole(0, 25, 25, 50, 50, false, HoleType.none, false);
    this.app.creating = new CreatingCard(0, [],[], [hole], this.cardBackList[0]);
    this.createHolesInBack();
    this.drawEditingCanvas();
  }

  startCreatingCard() {
    this.app.showIntro = false;
    this.app.showAllButtons = true;
    this.canvasWidth = 0;
    this.canvasHeight = 0;
  }

  goToManageCards() {
    this.app.broadcast({event: 'setTertiaryOne'});
  }

  expandTabClicked() {
    console.log("Expand tab clicked");
    this.showBackOptions = !this.showBackOptions;
  }

  runPreviewMaker(stage: any, layer: any, images: any = null, addAnchors = true) {
    let temp = [];
    if (images !== null) {
      let typeImage = images.filter((i) => {
        return i.type === "image" && i.src !== '/assets/Blank Image.jpg';
      });
      let typeText = images.filter((t) => {
        return t.type === "text";
      });
      typeImage.forEach((i) => {
        temp.push(i);
      });
      typeText.forEach((i) => {
        temp.push(i);
      });
    } else {
      let typeImage = this.app.images.filter((i) => {
        return i.type === "image" && i.src !== '/assets/Blank Image.jpg';
      });
      let typeText = this.app.images.filter((t) => {
        return t.type === "text";
      });
      typeImage.forEach((i) => {
        temp.push(i);
      });
      typeText.forEach((i) => {
        temp.push(i);
      });
    }
    let hasResize = false;
    let width = 0;
    let height = 0;
    let itemWithResize = null;
    temp.forEach((i) => {
      if (i.type === "image") {
        this.createNewImage(i, i.src, i.draggable, i.resizable, i.width, i.height, i.x, i.y, layer);
      } else if (i.type === "text") {
        this.createTextImage(i, layer);
      }
      hasResize = i.resizable ? true : hasResize;
      if (hasResize && i.resizable) {
        width = i.width;
        height = i.height;
        itemWithResize = i;
      }
    });
    if (!itemWithResize) { //Rare occurrence
      for (let i = 0; i < temp.length; i++) {
        let item = temp[i];
        if (item.type === "image") {
          width = item.width;
          height = item.height;
          itemWithResize = item;
        }
      }
    }
    if (hasResize && addAnchors && this.inFormatMode) {
      if (itemWithResize.type === "text" && (itemWithResize.imageSave === null || itemWithResize.imageSave === undefined)) {
        // console.log("Waiting...");
        // This ability was taken away since I wasn't able to get it to work, may revisit later
        //Going to have to wait...
      } else {
        this.finishAddAnchors(itemWithResize, width, height, false);
      }
    } else if (addAnchors && this.app.inCropMode) {
      if (itemWithResize.type === "text" && (itemWithResize.imageSave === null || itemWithResize.imageSave === undefined)) {
        // console.log("Can't do the crop text");
      } else {
        itemWithResize.resizable = false;
        this.finishAddAnchors(itemWithResize, width, height, true);
      }
    } else {
      if (this.drawCanvasDefer) {
        this.drawCanvasDefer();
        this.drawCanvasDefer = null;
      }
    }
  }

  textImageLoaded(image, info, layer) {
    this.createNewImage(info, image.src, info.resizable, info.resizable,
      image.wPos, image.hPos, info.xPos, info.yPos, layer);
  }

  _addCropAnchor(image, group, x, y, name, line = false) {
    let stage = group.getStage();
    let layer = group.getLayer();

    let anchor = new Konva.Rect({
      x: x,
      y: y,
      stroke: '#ffffff',
      width: 16,
      height: 16,
      fill: "red",
      name: name,
      strokeWidth: 0,
      draggable: true,
      dragOnTop: false
    });

    anchor.on('dragmove', () => {
      console.log("Crop Drag move");
      this.dragMove(anchor, layer, true, null);
      this.clearUpdating();
    });
    anchor.on('mousedown touchstart', () => {
      // console.log("Crop Mouse down");
      this.mouseDown(anchor, group);
    });
    anchor.on('dragend', () => {
      // console.log("Crop Drag end");
      group.setDraggable(false);
      layer.draw();
    });
    // add hover styling
    anchor.on('mouseover', function() {
      // console.log("Crop Mouse over");
      let layer = this.getLayer();
      document.body.style.cursor = 'pointer';
      this.setStrokeWidth(4);
      layer.draw();
    });
    anchor.on('mouseout', function() {
      // console.log("Crop Mouse out");
      let layer = this.getLayer();
      document.body.style.cursor = 'default';
      this.setStrokeWidth(2);
      layer.draw();
    });

    group.add(anchor);
  }

  _drawCropLines(group) {
    let topLeft = group.get('.topLeft')[0];
    let topRight = group.get('.topRight')[0];
    let bottomRight = group.get('.bottomRight')[0];
    let bottomLeft = group.get('.bottomLeft')[0];

    // console.log("Top Left = X: " + topLeft.getX() + " Y: " + topLeft.getY());

    let tlX = topLeft.getX() + (this.cropCornersSize / 2);
    let tlY = topLeft.getY() + (this.cropCornersSize / 2);
    let trX = topRight.getX()  + (this.cropCornersSize / 2);
    let trY = topRight.getY()  + (this.cropCornersSize / 2);

    let brX = bottomRight.getX() + (this.cropCornersSize / 2);
    let brY = bottomRight.getY() + (this.cropCornersSize / 2);
    let blX = bottomLeft.getX() + (this.cropCornersSize / 2);
    let blY = bottomLeft.getY() + (this.cropCornersSize / 2);

    this.addCropLine(group, tlX  + (this.cropCornersSize / 2), tlY, trX  - tlX - (this.cropCornersSize),
      true, "topLine", "red");
    this.addCropLine(group, trX, trY  + (this.cropCornersSize / 2), brY  - trY - (this.cropCornersSize), false, "rightLine", "red");
    this.addCropLine(group, tlX, tlY  + (this.cropCornersSize / 2), blY  - tlY - (this.cropCornersSize), false, "leftLine", "red");
    this.addCropLine(group, blX  + (this.cropCornersSize / 2), blY, brX  - blX - (this.cropCornersSize), true, "bottomLine", "red");
  }

  _addCropLine(group, x, y, length, toSide, name, color) {
    let anchor = new Konva.Rect({
      x: x,
      y: y,
      stroke: color,
      width: toSide ? length : 2,
      height: toSide ? 2: length,
      fill: color,
      name: name,
      strokeWidth: 1
    });

    group.add(anchor);
  }

  dragCheckFails(image, group) { //Return fail
    if (image.attrs.width !== null && image.attrs.height !== null &&
      !Number.isInteger(image.attrs.width) || !Number.isInteger(image.attrs.height)) {
      // console.log("Not an integer A");
      return true;
    }
    if (group.attrs.x !== null && group.attrs.y !== null &&
      !Number.isInteger(group.attrs.x) || !Number.isInteger(group.attrs.y)) {
      // console.log("Not an integer B");
      return true;
    }
    if (image.attrs.x && image.attrs.y)  {
      if (!Number.isInteger(image.attrs.x) || !Number.isInteger(image.attrs.y)) {
        // console.log("Not an integer C");
        return true;
      }
    }
    return false;
  }

  dragMove(anchor, itemWithResize: CardImage, layer, crop = false, image = null) {
    // console.log("Anchor dragging", anchor);
    this.update(anchor, crop, itemWithResize);
    this.layer.draw();
  };

  mouseDown(anchor, group) {
    // console.log("Mouse down");
    group.setDraggable(false);
    anchor.moveToTop();
  };

  changeImage() {
    $('#fileUpload').click();
  }

  removeImage() {
    // console.log("Remove image");
    if (this.app.selectedImage.type !== "text") {
      this.app.imageChanged = false;
      this.app.hasImageAdded = false;
    }
    this.app.images = this.app.images.filter((i) => {
      if (this.app.selectedImage.type === "image") {
        return i.type !== "image";
      } else {
        return (this.app.selectedImage.width !== i.width && this.app.selectedImage.height !== i.height
          && this.app.selectedImage.x !== i.x && this.app.selectedImage.y !== i.y);
      }
    });
    this.app.selectedImage = null;
    let count = 0;
    this.app.images.forEach((i) => {
      i.id = count;
      count++;
    });
    let found = false;
    for (let i = 0; i < this.app.images.length; i++) {
      let image = this.app.images[i];
      if (image.type === "text") {
        found = true;
        this.app.selectedImage = image;
        setTimeout(() => {
          this.imageClicked(this.app.selectedImage);
        }, 300);
      }
    }
    this.drawPreviewCanvas();
    this.setUpdatePreview();
  }

  addTextImage() {
    let textItemCount = this.countTextObjects();
    if (textItemCount >= 4) {
      this.app.errorText = "You have reached the maximum number of text boxes already. Please consider combining some to add more text.";
      $('#errorModal').modal('show');
      return;
    }
    if (textItemCount > 0) {
      let lastTextItem = null;
      for (let i = this.app.images.length - 1; i >= 0; i--) {
        if (this.app.images[i].type === "text") {
          lastTextItem = this.app.images[i];
          break;
        }
      }
      this.setupNewTextImage(this.app.images.length, "text", '', false, true,
        200, 200, 150, 250, false,
        {text: "(Type Here)", fontSize: lastTextItem.textSetup.fontSize, font: lastTextItem.textSetup.font, color: lastTextItem.textSetup.color});
    } else {
      this.setupNewTextImage(this.app.images.length, "text", '', false, true,
        200, 200, 150, 250, false, {text: "(Type Here)", fontSize: 30, font: "Arial", color: "#000000"});
    }

    this.app.selectedImage = this.app.images[this.app.images.length - 1];
    this.app.images.forEach((i) => {
      i.draggable = false;
      i.resizable = false;
    });
    this.app.selectedImage.draggable = true;
    if (this.app.selectedImage.type === "image") {
      this.app.selectedImage.resizable = true;
    }
    this.drawPreviewCanvas();
    this.setUpdatePreview();
  }

  _runImageDefer() {
    // this.drawPreviewCanvas();
    // this.setUpdatePreview();
  }

  showColorInfo() {
    console.log("SHow color info");
    this.app.errorText = "Change the card color by either selecting the color bar or using \"Color in Image\" where you can match a color in your photo.";
    $('#errorModal').modal('show');
  }

  createPreviewImage(addBack = true) {
    // console.log("In create preview image");
    if (this.app.selectedImage !== null && this.app.selectedImage.type === "image") {
      this.app.selectedImage.resizable = false;
    }
    this.setupNewImage(this.app.images.length,  "image", this.app.creating.cardBack.holedBack,
      false, false, this.canvasWidth, this.canvasHeight, 0, 0, false);
    this.getSnapshot(addBack, null, false);
    // console.log("After first draw preview canvas");
    setTimeout(() => {
      // console.log("Inside of timeout");
      let element = document.getElementById("previewGenerator");
      let canvas: any = element.children[0].children[0];
      let ctx = canvas.getContext('2d');
      let height = canvas.height;
      let width = canvas.width;
      // this.clipCanvas(ctx, 50, 50, 100, 100);
      let image = new Image();
      // console.log("After setup image object");
      image.onload = () => {
        // console.log("Image loaded");
        this.app.images.splice(this.app.images.length - 1, 1);
        if (this.app.selectedImage !== null && this.app.selectedImage.type === "image") {
          this.app.selectedImage.resizable = true;
        }
        // console.log("Before second draw preview");
        this.drawPreviewCanvas();
        // console.log("After secondd draw preview");
        // console.log("Images: ", this.app.createClone(this.app.images));
        let prev: any = document.getElementById("cardPreviewImg");
        prev.height = height;
        prev.width = width;
        let prevCont = prev.getContext('2d');
        // console.log("Height: ", height);
        // console.log("Width: ", width);
        prevCont.drawImage(image, 0, 0);
        this.previewedCard = './assets/1.jpg';
        this.runningUpdate = false;
      };
      image.src = canvas.toDataURL("image/png", 1);
      // console.log("After to data url");
    }, 500);
  }

  createNewCardToSave() {
    if (this.app.creating.cardImage.length === 0) {
      alert("Please add an image to create a card back.");
      return;
    }
    if (this.app.creating.cardBack.id === 0) {
      alert("Please select a pattern for your card back.");
      return;
    }
    if (this.app.creating.cardHoles[0].type === HoleType.none) {
      alert("Please select a frame shape for your card back.");
      return;
    }
    let canvas: any = document.getElementById('cardBackMaker');
    var snapshot = canvas.toDataURL("image/png", 1);
    var styleObject = this.makeStyleObject(snapshot);
    console.log("Saving card back: ", styleObject);
    this.app.makeNewCardBack(styleObject).subscribe((data: any) => {
      console.log("Orig style object: ", styleObject);
      console.log("Card back saved! ", data);
      this.app.userCards.push(data);
      this.app.selectedSavedCard = data;
      this.app.broadcast({event: 'imageSaved'});
    }, (error) => {
      console.log("Save card back error: ", error);
    });
  }

  overwriteCard() {
    if (this.app.creating.cardImage.length === 0) {
      alert("Please add an image to create a card back.");
      return;
    }
    if (this.app.selectedSavedCard !== null) {
      var id = this.app.selectedSavedCard.id;
      let canvas: any = document.getElementById('cardBackMaker');
      var snapshot = canvas.toDataURL("image/png", 1);
      var styleObject = this.makeStyleObject(snapshot);
      console.log("Saving card back: ", styleObject);
      this.app.updateCardBack(id, styleObject).subscribe((data: any) => {
        for (let i = 0; i < this.app.userCards.length; i++) {
          let card = this.app.userCards[i];
          if (card.id === id) {
            this.app.userCards[i] = data;
            break;
          }
        }
        this.app.selectedSavedCard = data;
        this.app.broadcast({event: 'imageSaved'});
      }, (error) => {
        // console.log("Save card back error: ", error);
      });
    }
  }

  runAddImage() {
    // console.log("In run add image");
    if (this.app.selectedImage !== null && this.app.selectedImage.type === "image") {
      this.app.selectedImage.resizable = false;
    }
    if (this.app.images.length === 0) {
      alert("You don't have any images or text added to create an image with.");
      return;
    }
    // console.log("Running add image");
    this.setupNewImage(this.app.images.length,  "image", this.app.selectedCardBack.src, false, false,
      this.canvasWidth, this.canvasHeight, 0, 0, false);
    this.drawPreviewCanvas(true);
    // console.log("After first draw preview canvas");
    setTimeout(() => {
      // console.log("Inside of timeout");
      let element = document.getElementById("container");
      let canvas: any = element.children[0].children[0];
      let ctx = canvas.getContext('2d');
      // ctx.fillStyle = "#f90";
      // ctx.fillRect(0, 0, 200, 200);
      // this.clipCanvas(ctx, 0, 0, 200, 200);
      let image = new Image();
      image.crossOrigin = "Anonymous";
      // console.log("After setup image object");
      image.onload = () => {
        // console.log("Image loaded");
        this.app.images.splice(this.app.images.length - 1, 1);
        if (this.app.selectedImage !== null && this.app.selectedImage.type === "image") {
          this.app.selectedImage.resizable = true;
        }
        // console.log("Before second draw preview");
        this.drawPreviewCanvas();
        // console.log("After secondd draw preview");
        let canvasSnapshot = image.src;
        canvasSnapshot = canvasSnapshot.replace('data:image/png;base64,', '');
        canvasSnapshot = canvasSnapshot.replace('data:image/jpg;base64,', '');
        let styleObject: CardCreatorStyle = this.makeStyleObject(canvasSnapshot);
        // console.log("Before defer");
        if (this.snapshotDefer !== null) {
          let id = this.runOverwrite ? this.app.selectedSavedCard.id : 0;
          this.snapshotDefer(id, styleObject, this.tempImageData);
          this.tempImageData = null;
          this.snapshotDefer = null;
        }
      };
      image.src = canvas.toDataURL("image/png", 1);
      // console.log("After to data url");
    }, 500);
  }

  clipCanvas(ctx, x, y, w, h) {

    ctx.globalCompositeOperation = 'destination-out';

    // ctx.filter = "blur(25px)";  // "feather"
    ctx.beginPath();
    ctx.moveTo(x + (w / 2), y);
    ctx.lineTo(x + w, y + h);
    ctx.lineTo(x, y + h);
    // ctx.moveTo(x + (w / 2), y);
    ctx.closePath();
    // ctx.stroke();
    // ctx.arc(x, y, w, 0, 2 * Math.PI);
    ctx.clip();
    ctx.clearRect(0, 0, 200, 200);

    // reset comp. mode and filter
    ctx.globalCompositeOperation = 'source-over';
    ctx.filter = "none";
  }

  makeStyleObject(snapshot: string) : CardCreatorStyle {
    let style = new CardCreatorStyle();
    style.sponsor = this.app.user.id;
    style.style = snapshot.replace('data:image/png;base64,', '');
    style.card_back = this.app.creating.cardBack.id;
    let textItems = [];
    let image: CardImage = this.app.creating.cardImage[0];
    this.tempImageData = image.src;
    let uploadedPic = image.src.replace('data:image/png;base64,', '');
    uploadedPic = uploadedPic.replace('data:image/jpg;base64,', '');
    style.uploaded_image = uploadedPic;
    style.image_pos_x = (image.xPos / this.canvasWidth) * 100;
    style.image_pos_y = (image.yPos / this.canvasHeight) * 100;
    style.height = this.canvasHeight;
    style.width = this.canvasWidth;
    style.hue = this.hueSlider;
    style.luminosity = this.lumSlider;
    style.saturation = this.satSlider;
    style.image_size_width = (image.wPos / this.canvasWidth) * 100;
    style.image_size_height = (image.hPos / this.canvasHeight) * 100;
    style.background_color = this.app.backgroundColor;
    this.app.creating.cardText.forEach((t) => {
      style.text_items.push(this.makeStyleText(t));
    });
    this.app.creating.cardHoles.forEach((h) => {
      style.cutouts.push(this.makeCutoutStyle(h));
    });
    return style;
  }

  makeCutoutStyle(item: CardHole) : StyleCreatorCutout {
    var style = new StyleCreatorCutout();
    style.x = (item.xPos / this.canvasWidth) * 100;
    style.y = (item.yPos / this.canvasHeight) * 100;
    style.width = (item.wPos / this.canvasWidth) * 100;
    style.height = (item.hPos / this.canvasHeight) * 100;
    style.type = item.type;
    style.borderWidth = item.borderWidth;
    style.borderColor = item.borderColor;
    return style;
  }

  makeStyleText(item) : StyleCreatorText {
    let style = new StyleCreatorText();
    style.text = item.textSetup.text;
    style.font = item.textSetup.font;
    style.font_size = item.textSetup.fontSize;
    style.font_color = item.textSetup.color;
    style.font_pos_x = (item.xPos / this.canvasWidth) * 100;
    style.font_pos_y = (item.yPos / this.canvasHeight) * 100;
    return style;
  }

  _cardBackClicked(cardBack) {
    // console.log("Card back click: ", cardBack);
    cardBack.src = cardBack.origBack;
    cardBack.wheel = [];
    this.setupColorWheels(cardBack);
    this.originalCard = cardBack;
    this.cbOriginalData = null;
    this.app.selectedCardBack = cardBack;
    this.colorTest = this.app.createClone(this.app.selectedCardBack.main);
    this.setUpdatePreview();
  }

  _setupColorWheels(cardBack: CardBack) {
    // console.log("Update color wheel");
    if (cardBack.hwheel.length === 0 || cardBack.updateWheels) {
      // console.log("In update");
      cardBack.hwheel = [];
      cardBack.swheel = [];
      cardBack.lwheel = [];
      this.cardBackColor = cardBack.main;
      let rgb = this.hexToRgb(cardBack.main);
      let hsl = this.rgbToHsl(rgb.r, rgb.g, rgb.b);

      let hue = hsl.h * 240;
      let sat = hsl.s * 240;
      let lum = hsl.l * 240;
      cardBack.hue = hue;
      cardBack.saturation = sat;
      cardBack.luminosity = lum;

      if (cardBack.updateWheels) {
        hsl.h = this.hueSlider / 240;
      }

      for (let i = 0; i <= 360; i = i + 10) {
        let hRgb = this.hslToRgb(i / 360, 1, .5); //Hardcoded the s,l values to visible colors on hue slider
        let hhex = this.rgbToHex(hRgb);
        cardBack.hwheel.push(hhex);

        let sRgb = this.hslToRgb(hsl.h, i / 360, .5); //Hardcoded the s,l values to visible colors on hue slider
        let shex = this.rgbToHex(sRgb);
        cardBack.swheel.push(shex);

        let lRgb = this.hslToRgb(hsl.h, 1, i / 360); //Hardcoded the s,l values to visible colors on hue slider
        let lhex = this.rgbToHex(lRgb);
        cardBack.lwheel.push(lhex);
      }
      // if (!cardBack.updateWheels) {
      this.hueSlider = Math.floor(hue);
      this.satSlider = Math.floor(sat);
      this.lumSlider = Math.floor(lum);
      // }
      cardBack.updateWheels = false;
    }
  }

  _createTextImage(imageInfo, layer: any) {
    let textWidth = this.getTextWidth(imageInfo);
    let canvas2 = document.createElement("canvas");
    canvas2.style.display = "none";
    document.body.appendChild(canvas2);
    let ctx2 = canvas2.getContext("2d");
    imageInfo.width = Math.ceil(textWidth);
    imageInfo.height = Math.ceil(imageInfo.textSetup.fontSize * 1.75);
    canvas2.width = Math.ceil(textWidth + 10);
    canvas2.height = Math.ceil(imageInfo.textSetup.fontSize * 1.75);
    ctx2.font = "" + imageInfo.textSetup.fontSize + "px " + imageInfo.textSetup.font;
    ctx2.textAlign = "center";
    ctx2.fillStyle = imageInfo.textSetup.color;
    ctx2.strokeStyle = 'black';
    ctx2.lineWidth = imageInfo.textSetup.fontSize > 40 ? 2 : 1;
    ctx2.fillText(imageInfo.textSetup.text, textWidth / 2, imageInfo.textSetup.fontSize + 5);
    ctx2.strokeText(imageInfo.textSetup.text, textWidth / 2, imageInfo.textSetup.fontSize + 5);

    let image = new Image();
    image.crossOrigin = "Anonymous";
    image.onload = () => {

    };
    image.src = canvas2.toDataURL("image/png", 1);
    this.textImageLoaded(image, imageInfo, layer);
    document.body.removeChild(canvas2);
  }

  _getTextWidth(imageInfo) {
    let canvas = document.createElement("canvas");
    canvas.style.display="none";
    document.body.appendChild(canvas);

    canvas.width = 600;
    canvas.height = 400;
    let ctx = canvas.getContext("2d");
    ctx.font = "" + imageInfo.textSetup.fontSize + "px " + imageInfo.textSetup.font;
    ctx.textAlign = "center";
    ctx.fillStyle = imageInfo.textSetup.color;
    let textWidth = ctx.measureText(imageInfo.textSetup.text).width;
    document.body.removeChild(canvas);
    return textWidth;
  }

  updateTextBox() {
    this.drawEditingCanvas();
    // this.setUpdatePreview();
  }

  updateFont(font) {
    this.app.selectedImage.textSetup.font = font.name;
    this.updateTextBox();
  }

  getFontList() {
    this.app.fontList = [
      "Arial",
      "Comic Sans MS",
      "Courier New",
      "Georgia",
      "Impact",
      "Lucida Console",
      "Lucida Sans Unicode",
      "Times New Roman",
      "Tahoma",
      "Trebuchet MS",
      "Verdana",
    ];
  }

  getPreviewStyle() {
    let container = document.getElementById("canvasContainer");
    if (container === null) return {};
    let height = this.canvasHeight > 0 ? this.canvasHeight : container.clientHeight;
    let width = container.clientWidth;
    let widthSize = this.canvasWidth > 0 ? this.canvasWidth : (width - 30);
    let heightSize = Math.ceil(widthSize * 1.4463);
    if (heightSize > (height)) {
      heightSize = (height);
      widthSize = Math.ceil((height) / 1.4463);
    }
    let top = Math.ceil((height - heightSize) / 2);

    let left = (width - widthSize) / 2;
    return {top: 0, left: left + 'px', 'width': this.canvasWidth + 'px', 'pointer-events': 'none',
      'opacity': this.app.viewMode === 1 ? 1 : 0,
      'height' : this.canvasHeight + 'px'};
  }

  testTap = (event) => {
    console.log("Test tap event: ", event);
    if (this.app.creating.cardHoles.length > 0) {
      this.app.creating.cardHoles[0].resizing = true;
      this.drawEditingCanvas();
    }
    if (this.app.selectedImage !== null) {
      this.app.selectedImage.resizable = false;
      this.app.selectedImage = null;
    }
  }

  getCanvasCenter(background = null) {
    let container = document.getElementById("canvasContainer");
    if (container === null) return {};
    let height = this.canvasHeight > 0 ? this.canvasHeight : container.clientHeight;
    let width = container.clientWidth;
    let widthSize = this.canvasWidth > 0 ? this.canvasWidth : (width - 30);
    let heightSize = Math.ceil(widthSize * 1.4463);
    if (heightSize > (height)) {
      heightSize = (height);
      widthSize = Math.ceil((height) / 1.4463);
    }
    let top = Math.ceil((height - heightSize) / 2);
    if (this.canvasHeight === 0 && this.canvasWidth === 0) {
      this.canvasHeight = heightSize;
      this.canvasWidth = widthSize;
    }
    let left = (width - widthSize) / 2;
    if (background === null) {
      return {'left': left + 'px', 'top': top + 'px',
        'width': this.canvasWidth + 'px', 'height' : this.canvasHeight + 'px',
        'cursor' : !this.app.clickPixelForColor ? 'auto' : 'crosshair'};
    } else {
      return {'left': left + 'px', 'top': top + 'px',
        'background-color' : background, 'width': this.canvasWidth + 'px',
        'height' : this.canvasHeight + 'px', 'cursor' : !this.app.clickPixelForColor ? 'auto' : 'crosshair'};
    }
  }

  getCardBackCenter(background = null) {
    let container = document.getElementById("canvasContainer");
    let height = this.canvasHeight > 0 ? this.canvasHeight : container.clientHeight;
    let width = container.clientWidth;
    let widthSize = this.canvasWidth > 0 ? this.canvasWidth : (width - 30);
    let heightSize = Math.ceil(widthSize * 1.4463);
    if (heightSize > (height)) {
      heightSize = (height);
      widthSize = Math.ceil((height) / 1.4463);
    }
    let top = Math.ceil((height - heightSize) / 2);

    let left = (width - widthSize) / 2;
    if (background === null) {
      return {'left': left + 'px', 'top': top + 'px',
        'width': this.canvasWidth + 'px', 'height' : this.canvasHeight + 'px'};
    } else {
      return {'left': left + 'px', 'top': top + 'px',
        'background-color' : background, 'width': this.canvasWidth + 'px', 'height' : this.canvasHeight + 'px'};
    }
  }

  getCanvasWidthAndHeight() {
    let container = document.getElementById("container");
    if (container === null) return {w: 100, h: 100};
    let height = this.canvasHeight > 0 ? this.canvasHeight : container.clientHeight;
    let width = this.canvasWidth > 0 ? this.canvasWidth : container.clientWidth;
    let widthSize = width;
    let heightSize = Math.ceil(widthSize * 1.6);
    return {w: widthSize, h: heightSize};
  }

  imageClicked(image) {
    // console.log("Image clicked in hierarchy: ", image);

    this.app.selectedImage = image;
    this.app.images.forEach((i) => {
      i.draggable = false;
      i.resizable = false;
    });
    if (image.type === "text") {
      for (let i = 0; i < this.app.images.length; i++) {
        if (this.app.images[i].id === image.id) {
          this.app.images.splice(i, 1);
          break;
        }
      }
      this.app.images.push(image);
      //Moving the test item to the end so it is on top and draggable
    }

    image.draggable = true;
    image.resizable = true;
    this.drawPreviewCanvas();
  }

  getTemplateStyle(template) {
    let el = document.getElementById("template" + template.id);
    if (!el) {
      return {};
    }
    let height = el.clientHeight;
    let width = el.clientWidth;

    template.width = width - 30;
    template.height = Math.ceil((width - 30) * 1.4463);
    template.elHeight = height;
    this.cardBackHeight = height;
    let margin = 10;
    if (template.elHeight) {
      margin = Math.ceil((template.elHeight - template.height) / 2);
    }
    return (this.app.creating.template !== null && template.id === this.app.creating.template.id) ?
      {'border': '1px solid green', 'box-shadow' : '1px 1px 7px 2px #ffd11a', 'padding': '10px',
        'height': (Math.ceil((width - 10) * 1.6)) + 'px'} :
      {'border': '1px solid black', 'padding': '10px', 'height': (Math.ceil((width - 10) * 1.6)) + 'px'};
  }

  getCardBackDisplayStyle(cardBack) {
    let el = document.getElementById("cardBack" + cardBack.id);
    if (!el) {
      return {};
    }
    let height = el.clientHeight;
    let width = el.clientWidth;

    cardBack.width = width - 30;
    cardBack.height = Math.ceil((width - 30) * 1.4463);
    cardBack.elHeight = height;
    this.cardBackHeight = height;
    let margin = 10;
    if (cardBack.elHeight) {
      margin = Math.ceil((cardBack.elHeight - cardBack.height) / 2);
    }
    return cardBack.id === this.app.creating.cardBack.id ?
      {'border': '1px solid green', 'box-shadow' : '1px 1px 7px 2px #ffd11a', 'padding': '10px',
        'height': (Math.ceil((width - 10) * 1.6)) + 'px'} :
      {'border': '1px solid black', 'padding': '10px', 'height': (Math.ceil((width - 10) * 1.6)) + 'px'};
  }

  getBlankCardStyle(cardBack) {
    if (!cardBack.elHeight || this.cardBackHeight < 100) {
      return {'display': 'none'};
    }
    if (!this.app.hasRunBlankRefresh) {
      this.app.hasRunBlankRefresh = true;
      setTimeout(() => {
        let cb = $('#cardBack0');
        if (cb !== null) {
          cb.click();
        }
      });
    }

    return {'line-height': this.cardBackHeight + 'px', 'height': this.cardBackHeight + 'px'};
  }

  getOrientation(file, callback) {
    let reader = new FileReader();
    reader.onload = (e: any) => {
      // console.log("getOrientation");
      let view = new DataView(e.target.result);
      if (view.getUint16(0, false) !== 0xFFD8)
        return callback(-2);
      let length = view.byteLength, offset = 2;
      while (offset < length) {
        let marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966)
            return callback(-1);
          let little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          let tags = view.getUint16(offset, little);
          offset += 2;
          for (let i = 0; i < tags; i++)
            if (view.getUint16(offset + (i * 12), little) === 0x0112)
              return callback(view.getUint16(offset + (i * 12) + 8, little));
        }
        else if ((marker & 0xFF00) !== 0xFF00) break;
        else offset += view.getUint16(offset, false);
      }
      return callback(-1);

    };
    reader.readAsArrayBuffer(file);
  }

  ////////////////////////
// Helper functions
//

  rgbToHsl(r, g, b){
    r /= 255, g /= 255, b /= 255;
    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    if(max == min){
      h = s = 0; // achromatic
    }else{
      let d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch(max){
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }
    return({ h:h, s:s, l:l });
  }

  hslToRgb(h, s, l){
    let r, g, b;
    if(s == 0){
      r = g = b = l; // achromatic
    }else{
      let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      let p = 2 * l - q;
      r = this.hue2rgb(p, q, h + 1/3);
      g = this.hue2rgb(p, q, h);
      b = this.hue2rgb(p, q, h - 1/3);
    }
    return({
      r:Math.round(r * 255),
      g:Math.round(g * 255),
      b:Math.round(b * 255),
    });
  }

  hue2rgb(p, q, t){
    if(t < 0) t += 1;
    if(t > 1) t -= 1;
    if(t < 1/6) return p + (q - p) * 6 * t;
    if(t < 1/2) return q;
    if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
    return p;
  }

  usingClickPixelForColor() {
    this.app.clickPixelForColor = !this.app.clickPixelForColor;
  }

  editTabChanged(val) {
    // console.log("At edit tab changed: ", val);
    this.drawEditingCanvas();
  }

  setupCardForEditing = (savedCard: CardCreatorStyle) => {
    this.app.getUploadedImage(savedCard.id).subscribe((data) => {
      // console.log("Card back bytes: ", data);
      let bytes = "data:image/jpg;base64," + data;
      setTimeout(() => {
        this.createEditingCard(savedCard, bytes);
      }, 300);
    }, (error) => {
      // console.log("Card bytes error: ", error);
      alert("There was an issue retrieving your image from the server");
    });
  }

  createEditingCard = (card: CardCreatorStyle, bytes: string) => {
    console.log("AAAAAAAA Starting to setup card for editing");
    var back = this.cardBackList[card.card_back];
    back.hue = card.hue;
    back.saturation = card.saturation;
    back.luminosity = card.luminosity;
    back.src = back.origBack;
    back.updatedBack = back.origBack;
    this.originalCard = back;
    this.cbOriginalData = null;
    var prevWasBlank = this.app.creating.cardBack.id === 0;
    let rgb = this.hslToRgb(card.hue / 240, card.saturation / 240, card.luminosity / 240);
    this.hueSlider = card.hue;
    this.satSlider = card.saturation;
    this.lumSlider = card.luminosity;
    console.log("RGB: ", rgb);
    this.cardBackColor = "#" + rgb.r.toString(16) + "" + rgb.g.toString(16) + "" + rgb.b.toString(16) + "";
    console.log("Card back color: ", this.cardBackColor);
    $('#cardColor').val(this.cardBackColor);
    this.app.backgroundColor = card.background_color;
    this.app.creating = new CreatingCard(0, [],[], [], back);
    card.cutouts.forEach((hole) => {
      var h = new CardHole(this.app.creating.cardHoles.length, hole.x,
        hole.y, hole.width, hole.height, false, hole.type);
      h.borderColor = hole.borderColor;
      h.borderWidth = hole.borderWidth;
      this.app.creating.cardHoles.push(h);
    });
    card.text_items.forEach((t) => {
      var textImage = new CardImage(this.app.creating.cardText.length, ImageType.text,
        '', false, false, 100, 100, t.font_pos_x, t.font_pos_y, false,
        new CardText(t.text, t.font_size, t.font, t.font_color, TextShape.NONE, '#FFFFFF',
          '#FFFFFF', 0, 0, 0));
      this.app.creating.cardText.push(textImage);
    });
    var image = new CardImage(card.id, ImageType.image, bytes, false, false,
      card.image_size_width, card.image_size_height, card.image_pos_x, card.image_pos_y, false, null);
    image.hasLink = true;
    image.linkImage = card.uploaded_image;
    this.app.selectedImage = image;
    this.app.creating.cardImage.push(image);
    this.app.showIntro = false;
    this.app.hasImageAdded = true;
    if (this.cardBackColor !== "#ffffff") {
      this.hslChange();
    } else {
      this.createHolesInBack();
    }
    console.log("At the end of edit");
    setTimeout(() => {
      console.log("Draw the canvas: ", this.app.creating.cardImage[0].groupSave);
      // this.resetSubscription();
      this.hasMadeStage = false;
      this.layer.destroy();
      this.stage.destroy();
      this.drawEditingCanvas();
    }, 500);
  }

  broadCastHandle = (value: Object): void => {
    console.log("In broadcast handle");
    switch(value['event']) {
      case 'editCard':
        //This needs a delay due to a new handler being made
        console.log("In edit card");
        setTimeout(() => {
          value['event'] = 'finalizeEditCard';
          this.app.broadcast(value);
        }, 1500);
      case 'finalizeEditCard':
        console.log("In finalize card");
        let card = value['data'];
        console.log("Here at edit card", card);
        this.editClicked();
        this.app.showAllButtons = true;
        setTimeout(() => {
          this.setupCardForEditing(card);
        }, 300);
        break;
      case 'cardBackSelected':
        let back: CardBack = value['data'];
        console.log("Card back selected: ", back);
        this.cardBackClicked(back);
        break;
      case 'setUpdatePreview':
        this.setUpdatePreview();
        break;
      case 'addImage':
        this.addImage();
        break;
      case 'editImage':
        this.editImage();
        break;
      case 'deleteImage':
        this.deleteImage();
        break;
      case 'addTextImage':
        this.addNewTextImage();
        break;
      case 'imageClicked':
        this.imageClicked(value['data']);
        break;
      case 'updateFont':
        this.updateFont(value['data']);
        break;
      case 'updateTextBox':
        this.updateTextBox();
        break;
      case 'removeImage':
        this.removeImage();
        break;
      case 'createNewCard':
        this.createNewCardToSave();
        break;
      case 'overwriteCard':
        this.overwriteCard();
        break;
      case 'editTabChanged':
        let val = value['data'];
        this.editTabChanged(val);
        break;
      case 'runCropImage':
        setTimeout(() => {
          this.startCropImage(0);
        });
        break;
      case 'runCropSquare':
        setTimeout(() => {
          this.startCropImage(0);
        });
        break;
      case 'runCropCircle':
        setTimeout(() => {
          this.startCropImage(1);
        });
        break;
      case 'runAcceptCrop':
        if (this.app.cropShape === 0) {
          this.acceptSquareCropImage();
        } else {
          this.acceptCircleCropImage();
        }
        break;
      case 'cropImageToFrame':
        if (this.app.creating.cardHoles.length === 0) return;
        switch(this.app.creating.cardHoles[0].type) {
          case HoleType.square:
            this.acceptSquareCropImage();
            break;
          case HoleType.circle:
            this.acceptCircleCropImage();
            break;
          case HoleType.diamond:
            this.acceptDiamondCropImage();
            break;
          case HoleType.club:
            this.acceptClubCropImage();
            break;
          case HoleType.spade:
            this.acceptSpadeCropImage();
            break;
          case HoleType.heart:
            this.acceptHeartCropImage();
            break;
          case HoleType.star:
            this.acceptStarCropImage();
            break;
          default:
            break;
        }
        break;
      case 'runCancelCrop':
        this.cancelCropImage();
        break;
      case 'updateEditingCanvas':
        this.createHolesInBack();
        this.drawEditingCanvas();
        break;
      case 'makeSnapshot':
        this.makeSnapshot();
        break;
      case 'backToCreation':
        this.app.showAllButtons = false;
        this.canvasHeight = 0;
        this.canvasWidth = 0;
        setTimeout(() => {
          this.canvasHeight = 0;
          this.canvasWidth = 0;
        }, 500);
        break;
      default:
        break;
    }
  }
}
